import Paper from "@mui/material/Paper";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import "./Configuration.scss";
import TextField from "@mui/material/TextField";
import Switch from "@mui/material/Switch";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import { ChangeEvent, ReactNode, useEffect, useRef, useState } from "react";
import ExcelJS from "exceljs";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import MenuItem from "@mui/material/MenuItem";
import MuiToggleButton from "@mui/material/ToggleButton";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
const { awsCronExpressionValidator } = require("aws-cron-expression-validator");
import Button from "@mui/material/Button";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { Control, Controller, useFieldArray, useForm } from "react-hook-form";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import Box from "@mui/material/Box";
import { useLocation, useNavigate } from "react-router-dom";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import momentTimeZone from "moment-timezone";
import {
  AppendType,
  AppendTypeForDNC,
  AppendTypeList,
  AppendTypeListForDNC,
  AuthenticationType,
  DNCContactMethod,
  DNCContactMethodList,
  DNCSourceType,
  DNCSourceTypeList,
  EmailType,
  FileFormatOperationTypeList,
  PhoneType,
  RoutesName,
  RulesType,
  initialConfigurationValue,
} from "../../common/constants";
import {
  FileSpecificationTemplate,
  IConfiguration,
  IDomainListItem,
  IScheduledTask,
  IUser,
  ImportTemplate,
} from "../../models";
import SchedulerDialog from "./schedulerDialog";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import moment from "moment";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Autocomplete from "@mui/material/Autocomplete";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import IconButton from "@mui/material/IconButton";
import cronstrue from "cronstrue";
import { getStorageItem } from "../../services/applicationStorage";
import {
  saveSftpConfiguration,
  getAllContactList,
  getAllDNCList,
  getUserMe,
  testConnection,
  testAPIConnection,
  getServerListService,
  updateSftpConfiguration,
  getExitingSftpConfiguration,
  getAllDomainList,
  getSSHPublicKey,
  getAllFileSpecificationTemplates,
  getAllImportTemplates,
  getSettingsConfiguration,
  getAllCampaign,
} from "../../services/purecloud";
import Snackbar from "@mui/material/Snackbar";
import Alert, { AlertColor } from "@mui/material/Alert";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Checkbox, Typography } from "@mui/material";
import ApiRetrieval from "../ApiRetrieval/ApiRetrieval";
import S3Storage from "../S3Storage/S3Storage";
import AppendOperationsSection from "./AppendOperationsSection";
import ColumnSelectionDialog from "./ColumnSelectionDialog";

const ToggleButton = styled(MuiToggleButton)({
  "&.Mui-selected, &.Mui-selected:hover": {
    color: "white",
    backgroundColor: "#1b2c48",
  },
  fontWeight: 700,
  color: "black",
  textAlign: "center",
});

interface ExcelRow {
  [key: string]: string;
}

/**
 * Configuration Component
 */
const Configuration = () => {
  const PhoneTypes = [
    {
      displayValue: "Cell",
      value: PhoneType.cell,
    },
    {
      displayValue: "Day Time",
      value: PhoneType.daytime,
    },
    {
      displayValue: "Evening",
      value: PhoneType.evening,
    },
    {
      displayValue: "Home",
      value: PhoneType.home,
    },
    {
      displayValue: "Work",
      value: PhoneType.work,
    },
  ];
  const EmailTypes = [
    {
      displayValue: "Personal",
      value: EmailType.personal,
    },
    {
      displayValue: "Work",
      value: EmailType.work,
    },
  ];
  const [contactListItems, setContactListItems] = useState<
    Array<{ id; name; phoneColumns; columnNames; division?: { id: string; name: string } }>
  >([]);
  const [storageType, setStorageType] = useState<string>("SFTP");
  
  const [dncListItems, setDncListItems] = useState<
    Array<{ id; name; phoneColumns; dncSourceType?: string; contactMethod?: string }>
  >([]);

  const [exportContactListItems, setExportContactListItems] = useState<
    Array<{ id; name; phoneColumns }>
  >([]);

  const [exportDNCItems, setExportDNCItems] = useState<
    Array<{ id; name; phoneColumns }>
  >([]);

  const [prefilledServer, setPreFilledServer] = useState<boolean>(false);
  const [campaignList, setCampaignList] = useState<
    Array<{
      id;
      name;
      contactList: { id; name };
      dncLists: Array<{ id; name; selfUri }>;
    }>
  >([]);
  const [fileSpecTemplateList, setFileSpecTemplateList] = useState<
    Array<FileSpecificationTemplate>
  >([]);
  const [importTemplateList, setImportTemplateList] = useState<
    Array<ImportTemplate>
  >([]);
  const [selectedImportTemplate, setSelectedImportTemplate] = useState<ImportTemplate | null>(null);
  const [splittingCriteriaContactLists, setSplittingCriteriaContactLists] = useState<Array<string>>([]);
  const [getPublicKeyDetails, setPublicKeyDetails] = useState<{
    publicKey: string;
    fingerprint: string;
  }>({ publicKey: "", fingerprint: "" });
  const [contactListColumns, setContactListColumns] = useState<
  Array<string>
  >([]);

  const [getServerList, setServerList] = useState<Array<any>>([]);
  const [getDisableSchedule, setDisableSchedule] = useState<boolean>(false); // change to false
  const [isSFTPCredsValid, setIsSFTPCredsValid] = useState<boolean>(false); // change to false
  const [getUserDetails, setUserDetails] = useState<IUser>({} as IUser);
  const [getSnackDetails, setSnackDetails] = useState({
    open: false,
    message: (<></>) as ReactNode,
    severity: "success",
  });
  const [selectedAdditionalAttribute, setSelectedAdditionalAttribute] =
    useState<string>("");

const [selectedTab, setSelectedTab] = useState<number>(0);
const [selectedSourceTab, setSelectedSourceTab] = useState<number>(0);

const [
    selectedAdditionalAttributeExport,
    setSelectedAdditionalAttributeExport,
  ] = useState<{
    zipFiles?: boolean;
    encryptFiles?: boolean;
    deleteFiles: boolean;
    clearAll: boolean;
    isMoveFiles: boolean;
    traceConnection: boolean;
    includeCustomFileName: boolean;
    customFileName: string;
    includeDateInFileName: boolean;
    includeTimeInFileName: boolean;
  }>({
    deleteFiles: false,
    clearAll: false,
    isMoveFiles: false,
    zipFiles: false,
    encryptFiles: false,
    traceConnection: true,
    includeCustomFileName: false,
    customFileName: "",
    includeDateInFileName: true,
    includeTimeInFileName: true,
  });
  const [isColumnDialogOpen, setIsColumnDialogOpen] = useState<boolean>(false);
  const [selectedExportColumns, setSelectedExportColumns] = useState<string[]>([]);
  let canWeEncryptExportOperation = true;
  const [isSchedulerDialogOpen, setSchedulerDialogOpen] =
    useState<boolean>(false);
  const [isFormDataLoading, setFormDataLoading] = useState<boolean>(false);
  const [isDSTEnabled, setIsDSTEnabled] = useState<boolean>(true);
  const [domainList, setDomainList] = useState<IDomainListItem[]>([]);
  const [excelData, setExcelData] = useState<ExcelRow[]>([]);
  const [excelHeaderCols, setExcelHeaderCols] = useState<string[]>([]);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const location = useLocation();
  const scheduledDate = useRef<String | null>(null);
  const fullServerDetails = useRef<Array<string | { serverName?: string; [key: string]: any }>>([]);

  const {
    register,
    handleSubmit,
    formState: { errors, isValid, isDirty },
    control,
    setValue,
    setError,
    watch,
  } = useForm({ defaultValues: initialConfigurationValue, mode: "onChange" });

  const {
    fields: phoneFields,
    append: phoneAppend,
    remove: phoneRemove,
  } = useFieldArray({
    control,
    name: "rules.importFile.contactListConfiguration.phoneColumns",
  });

  const navigate = useNavigate();
  const [portError, setPortError] = useState(false);
  const [customNotificationEmail, setCustomNotificationEmail] = useState<string[]>([]);
  const [emailErrors, setEmailErrors] = useState<string[]>([]);
  const [isFormValid, setIsFormValid] = useState<boolean>(false);

  const handleAddEmail = () => {
    const errors = [...emailErrors];
    let hasError = false;

    customNotificationEmail.forEach((email, index) => {
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errors[index] = "Invalid or empty email.";
        hasError = true;
      } else {
        errors[index] = "";
      }
    });

    setEmailErrors(errors);
    setValue("customNotificationEmail", customNotificationEmail);
    if (!hasError) {
      setCustomNotificationEmail([...customNotificationEmail, ""]);
      setEmailErrors([...emailErrors, ""]);
    }
  };

  const handleEmailChange = (index: number, value: string) => {
    const updatedEmails = [...customNotificationEmail];
    updatedEmails[index] = value;
    setCustomNotificationEmail(updatedEmails);
    setValue( "customNotificationEmail", updatedEmails);

    const errors = [...emailErrors];
    if (!value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      errors[index] = "Invalid or empty email.";
    } else {
      errors[index] = "";
    }
    setEmailErrors(errors);
  };

  const handleRemoveEmail = (index: number) => {
    const updatedEmails = customNotificationEmail.filter((_, i) => i !== index);
    const updatedErrors = emailErrors.filter((_, i) => i !== index);
    setCustomNotificationEmail(updatedEmails);
    setEmailErrors(updatedErrors);
    setValue("customNotificationEmail", updatedEmails);
  };

  const handlePopulateSplittingCriteria = () => {
    const originalListName = watch("rules.importFile.originalContactListName");
    if (!originalListName) return;
    
    const matchingLists = contactListItems
      .filter(list => list.name.startsWith(originalListName))
      .slice(0, 10);
    
    const matchingListIds = matchingLists.map(list => list.id);
    setSplittingCriteriaContactLists(matchingListIds.length > 0 ? matchingListIds : [""]);
    
    // Extract division and columns from the first matching list
    if (matchingLists.length > 0) {
      const firstList = matchingLists[0];
      
      // Set the division from the first matching list
      if (firstList.division?.id) {
        setValue(
          "rules.importFile.contactListConfiguration.division.id" as keyof IConfiguration,
          firstList.division.id
        );
      }
      
      // Set the columns for the unique ID dropdown
      if (firstList.columnNames && firstList.columnNames.length > 0) {
        setContactListColumns(firstList.columnNames);
      }
    }
  };

  useEffect(() => {
    (async () => {
      const queryParams = new URLSearchParams(location.search);
      let response;
      try {
        setFormDataLoading(true);
        // Since the date property is not setting properly above, so manual assigned it
        setValue("scheduleDetails.date", moment());
        if (queryParams.has("jobId")) {
          response = await getExitingSftpConfiguration(
            queryParams.get("jobId")
          );
          let dstFlag;

          if (response.data?.dstSupport){
            dstFlag = response.data.dstSupport;
          }
          else {
            dstFlag = false; // default to true if not specified
          }

          setStorageType(response.data?.storageType || "SFTP");
          let storageType = response.data?.storageType;
          if (storageType === "AWS-S3") {
            setSelectedSourceTab(2);
            setStorageType("AWS-S3");
          }
          setIsDSTEnabled(dstFlag);

          setDisableSchedule(true); // NOT allow change of schedule/non schedule after a job is saved (disable the schedule toggle for edit)
          if (response) {
            response = JSON.parse(JSON.stringify(response.data));
            // Convert UTC date to the timezone specified in scheduleDetails
            const utcDate = new Date(response.scheduleDetails.date);
            const timezone = response.scheduleDetails.timeZone;
            response.scheduleDetails.date = moment.tz(utcDate, timezone || 'UTC');
            if (response.scheduleDetails.cron) {
              const text: string = cronstrue.toString(
                response.scheduleDetails.cron as string,
                {
                  verbose: true,
                  // monthStartIndexZero: true,
                }
              );
              setValue("scheduleDetails.cronText", text);
            }
            if (response.serverDetails.additionalAttributes.deleteFiles) {
              setSelectedAdditionalAttribute("deleteFiles");
            } else if (response.serverDetails.additionalAttributes.clearAll) {
              setSelectedAdditionalAttribute("clearAll");
            } else if (
              response.serverDetails.additionalAttributes.isMoveFiles
            ) {
              setSelectedAdditionalAttribute("isMoveFiles");
            }

            setSelectedAdditionalAttributeExport({
              deleteFiles: false,
              clearAll: false,
              isMoveFiles: false,
              traceConnection: true,
              encryptFiles:
                response.serverDetails.additionalAttributes.encryptFiles,
              zipFiles: response.serverDetails.additionalAttributes.zipFiles,
              includeCustomFileName: response.serverDetails.additionalAttributes.includeCustomFileName || false,
              customFileName: response.serverDetails.additionalAttributes.customFileName || "",
              includeDateInFileName: response.serverDetails.additionalAttributes.includeDateInFileName !== undefined ? response.serverDetails.additionalAttributes.includeDateInFileName : true,
              includeTimeInFileName: response.serverDetails.additionalAttributes.includeTimeInFileName !== undefined ? response.serverDetails.additionalAttributes.includeTimeInFileName : true,
            });

            const updatedRules =
              response.rules.ruleType === RulesType.importFile
                ? {
                    ...response.rules,
                    [RulesType.exportContactList]:
                      initialConfigurationValue.rules.exportContactList,
                  }
                : {
                    ...response.rules,
                    [RulesType.importFile]:
                      initialConfigurationValue.rules.importFile,
                  };
            if (response.rules.ruleType === RulesType.importFile) {
              if (
                response.rules.importFile.appendType ===
                  AppendType.appendonly ||
                response.rules.importFile.appendType ===
                  AppendType.flushandappend ||
                response.rules.importFile.importTemplateId
              ) {
                response.rules.importFile.contactListConfiguration = {
                  name: "",
                  division: {
                    id: response.rules.importFile.importTemplateId
                      ? response.rules.importFile.division
                      : "",
                  },
                  useSpecificationFile: response.rules.importFile
                    .fileSpecificationTemplateId
                    ? true
                    : false,
                  useImportTemplate: response.rules.importFile.importTemplateId
                    ? true
                    : false,
                  trimWhitespace: true,
                  columnNames: [],
                  phoneColumns: [
                    { columnName: "", type: "", callableTimeColumn: "" },
                  ],
                };
              }
              setExcelHeaderCols(
                response.rules.importFile.contactListConfiguration.columnNames
              );
            }
            setValue("rules", { ...response.rules, ...updatedRules });
            setValue(
              "rules.importFile.contactListConfiguration.phoneColumns" as keyof IConfiguration,
              (response.rules?.importFile?.contactListConfiguration
                ?.phoneColumns as any) || [
                { columnName: "", type: "", callableTimeColumn: "" },
              ]
            );

            Object.keys(response).forEach((field) => {
              if (response[field]) {
                setValue(field as keyof IConfiguration, response[field]);
              }
            });

            // Populate API retrieval parameters if present
            if (response.apiRetrieval) {
              setValue("apiRetrieval", response.apiRetrieval);
            }
            // Populate list name for API integration
            if (response.listName && storageType === "API") {
              setValue("listName" as keyof IConfiguration, response.listName);
            }

            if (response.rules.ruleType === RulesType.exportContactList) {
              setValue(
                "rules.importFile.appendType" as keyof IConfiguration,
                AppendType.newlistsonly
              );
            }
            //Since the date property is not setting properly above, so manual assigned it
            setValue("scheduleDetails.date", response.scheduleDetails.date);
            if (response.rules.ruleType === RulesType.importDNCList) {
              const rulesToCopy = response.rules.importFile;
              delete response.rules.importFile;
              // Extract dncSourceType and contactMethod from contactListConfiguration and set at importDNCList level
              const dncSourceType = rulesToCopy.contactListConfiguration?.dncSourceType || DNCSourceType.rds_custom;
              const contactMethod = rulesToCopy.contactListConfiguration?.contactMethod;
              
              // Extract columns based on contact method
              // For Internal (rds), columns are stored in phoneNumberColumns/emailColumns/whatsAppColumns
              // For Internal-Custom (rds_custom), columns are stored in customExclusionColumns
              let dncColumns: string[] = [];
              const contactConfig = rulesToCopy.contactListConfiguration;
              if (dncSourceType === DNCSourceType.rds && contactMethod && contactMethod !== "any") {
                if (contactMethod === DNCContactMethod.phone && contactConfig?.phoneNumberColumns) {
                  dncColumns = contactConfig.phoneNumberColumns;
                } else if (contactMethod === DNCContactMethod.email && contactConfig?.emailColumns) {
                  dncColumns = contactConfig.emailColumns;
                } else if (contactMethod === DNCContactMethod.whatsapp && contactConfig?.whatsAppColumns) {
                  dncColumns = contactConfig.whatsAppColumns;
                }
              } else if (contactConfig?.customExclusionColumns) {
                dncColumns = contactConfig.customExclusionColumns;
              }

              // Set the columns back to customExclusionColumns for form display
              if (rulesToCopy.contactListConfiguration) {
                rulesToCopy.contactListConfiguration.customExclusionColumns = dncColumns;
              }

              setValue("rules", {
                ...response.rules,
                [RulesType.importDNCList]: {
                  ...rulesToCopy,
                  dncSourceType,
                  contactMethod: contactMethod && contactMethod !== "any" ? contactMethod : undefined,
                },
              });
              if (rulesToCopy.appendType === AppendTypeForDNC.newlistsonly || rulesToCopy.appendType === AppendTypeForDNC.appendonly) {
                setExcelHeaderCols(dncColumns);
              }
            } else if (response.rules.ruleType === RulesType.exportDNCList) {
              setValue(
                "rules.importDNCList.appendType" as keyof IConfiguration,
                AppendType.newlistsonly
              );
              const rulesToCopy = response.rules.exportContactList;
              delete response.rules.exportContactList;
              setValue("rules", {
                ...response.rules,
                [RulesType.exportDNCList]: rulesToCopy,
              });
            }
            if (response.customNotification !== undefined) {
              setValue("customNotification", response.customNotification);
              if (response.customNotificationEmail) {
                setCustomNotificationEmail(response.customNotificationEmail);
                setEmailErrors(response.customNotificationEmail.map(() => ""));
              }
            }
            // Restore selected export columns if present
            if (response.rules?.exportContactList?.selectedColumns) {
              setSelectedExportColumns(response.rules.exportContactList.selectedColumns);
            }
          }
        }else {
          let orgSettings = getStorageItem(
            "org-settings",
            true,
            sessionStorage
          );
          if (orgSettings) {
            orgSettings = JSON.parse(orgSettings);
            setStorageType(orgSettings.storageType || "SFTP");
            let storageType = orgSettings.storageType;
            if (storageType === "AWS-S3") {
              setSelectedSourceTab(2);
              setStorageType("AWS-S3");
            } else if (storageType === "API") {
              setSelectedSourceTab(1);
              setStorageType("API");
            }
          }
        } 
        

        const [
          contactList,
          dncList,
          allServerList,
          userDetails,
          allDomainList,
          publicKeyData,
          fileSpecs,
          importTemplates,
          sftpSettings,
          campaigns,
        ] = await Promise.all([
          getAllContactList(),
          getAllDNCList(),
          getServerListService().then((server) => {
            if (storageType === "AWS-S3") {
              return ((server?.data?.s3List as Array<string>) || []).sort(
                (a, b) => a.localeCompare(b)
              );
            } else {
              const allServerOptions = server.data.serverList.map((e: any) => {
                if (typeof e === "string") {
                  return { id: e, serverName: e, userName: "", isLegacy: true };
                }
                return { id: e.id, serverName: e.serverName, userName: e.userName, password: e.password, port: e.port, authType: e.authType, publicKey: e.publicKey, isLegacy: false };
              });
              fullServerDetails.current = server.data.serverList;
              let currentJob = watch("serverDetails.fileServer")
              let currentUserName = watch("serverDetails.userName")
              console.log({currentJob})

              const currentIsNewFormat = allServerOptions.find((opt: any) =>
                 (
                  ( opt.id === currentJob && opt.isLegacy == false ) ||
                  (opt.serverName === currentJob && opt.userName === currentUserName)
                )
              );

              if (currentIsNewFormat) {
                setValue("serverDetails.fileServer", currentIsNewFormat.id);
                setValue("serverDetails.userName", currentIsNewFormat.userName || "");
                setValue("serverDetails.password", currentIsNewFormat.password || "");
                setValue("serverDetails.port", currentIsNewFormat.port || 22);
                setValue("serverDetails.authenticationType", currentIsNewFormat.authType || AuthenticationType.password);
                setValue("serverDetails.publicKey", currentIsNewFormat.publicKey || "");
                setPreFilledServer(true);
              }

              return allServerOptions;
            }
          }),
          getUserMe(),
          getAllDomainList(),
          getSSHPublicKey(),
          getAllFileSpecificationTemplates(),
          getAllImportTemplates(),
          getSettingsConfiguration(),
          getAllCampaign(),
        ]);
        setContactListItems(contactList);
        setDncListItems(dncList);
        setExportContactListItems(contactList);
        setExportDNCItems(dncList);
        setServerList(allServerList || []);
        setUserDetails(userDetails || {});
        setDomainList(allDomainList as IDomainListItem[]);
        setPublicKeyDetails(publicKeyData.data);
        setFileSpecTemplateList(
          fileSpecs.sort((a, b) => a.name.localeCompare(b.name)) || []
        );
        setImportTemplateList(
          importTemplates.sort((a, b) => a.name.localeCompare(b.name)) || []
        );
        
        // Set selected import template if one is already selected
        if (response?.rules?.importFile?.importTemplateId) {
          const selectedTemplate = importTemplates.find(
            template => template.id === response.rules.importFile.importTemplateId
          );
          if (selectedTemplate) {
            setSelectedImportTemplate(selectedTemplate);
            if (selectedTemplate.useSplittingCriteria) {
              const existingLists = response.rules.importFile.splittingCriteriaContactLists || [];
              const contactListIds = existingLists.map(list => list.id);
              setSplittingCriteriaContactLists(contactListIds.length > 0 ? contactListIds : [""]);
            }
          }
        }
        const keys = sftpSettings?.data?.sftpSetting || [];
        canWeEncryptExportOperation = keys.some(
          (key) =>
            key.expDate === "Never" || moment(key.expDate).isAfter(moment())
        );
        if (!canWeEncryptExportOperation) {
          setSelectedAdditionalAttributeExport((prev) => ({
            ...prev,
            encryptFiles: false,
          }));
        }
        setCampaignList(campaigns);
        if (response?.rules?.exportContactList?.campaignId) {
          const campaign = campaigns.find(
            (campaign) =>
              campaign.id === response.rules.exportContactList.campaignId
          );
          const filteredContactList = contactList.find(
            (contact) => contact.id === campaign.contactList.id
          );
          if (filteredContactList) {            
            setExportContactListItems([filteredContactList]);
          } else {
            setExportContactListItems([]);
          }
        } else if (response?.rules?.exportDNCList?.campaignId) {
          const campaign = campaigns.find(
            (campaign) =>
              campaign.id === response.rules.exportDNCList.campaignId
          );
          const campaignDncLists = campaign.dncLists.map((item) => item.id);
          const filteredDncList = dncList.find((list) =>
            campaignDncLists.includes(list.id)
          );
          if (filteredDncList) {
            setExportDNCItems([filteredDncList]);
          } else {
            setExportDNCItems([]);
          }
        }

        setFormDataLoading(false);
      } catch (error) {
        setFormDataLoading(false);
        console.error("Error fetching data:", error);
      }
    })();
  }, []);

  //This hook is used to handle alert for un-saved UI changes
  useEffect(() => {
    //Refresh logic
    const handleBeforeUnload = (e) => {
      if (isDirty) {
        e.preventDefault();
        e.returnValue = ""; // Required for some browsers
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      // Clean up the event listener
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);



  /**
   * This method is used handle the file upload event
   * @param e file
   * @returns void
   */
  const handleFileUpload = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (file) {
      // Check if the file type is Excel or CSV
      if (!file.name.match(/\.(xlsx|xls|csv|txt|dat|dsv)$/)) {
        alert("Please upload CSV or Excel file");
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        return;
      }

      // Check if the file size is greater than 1MB
      if (file.size > 1024 * 1024) {
        alert("File size shouldn't be greater than 1MB");
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        return;
      }

      const reader = new FileReader();
      const fileExtension = file.name.split(".").pop()?.toLowerCase();
      reader.onload = async (event) => {
        let data = new Uint8Array(event.target?.result as ArrayBuffer);
        const ext = fileExtension?.toLocaleLowerCase();
        const isTextFormat =
          (watch(
            "rules.importFile.contactListConfiguration.useSpecificationFile"
          ) &&
            ext === "csv") ||
          ext === "dsv" ||
          ext === "dat" ||
          ext === "txt";

        if (isTextFormat) {
          const specId =
            watch("rules.importFile.fileSpecificationTemplateId") || "";
          if (specId) {
            const spec = fileSpecTemplateList.find((v) => v.id === specId);

            const delimitedObj = {
              Comma: ",",
              Colon: ":",
              Semicolon: ";",
              Tab: "  ",
              Pipe: "\\|",
              Custom: spec?.delimiterValue || ",",
            };

            const dataString = new TextDecoder().decode(data);
            const delimiter =
              spec?.format === "Delimited" ? delimitedObj[spec.delimiter] : ",";
            const modifiedDataString = dataString.replace(
              new RegExp(delimiter, "g"),
              ","
            );
            data = new TextEncoder().encode(modifiedDataString);
          }
        }

        let headerCols: string[] = [];
        let jsonData: ExcelRow[] = [];

        if (ext === "xlsx" || ext === "xls") {
          const workbook = new ExcelJS.Workbook();
          await workbook.xlsx.load(data.buffer as ArrayBuffer);
          const worksheet = workbook.worksheets[0];
          if (worksheet) {
            const firstRow = worksheet.getRow(1);
            firstRow.eachCell({ includeEmpty: false }, (cell) => {
              headerCols.push(String(cell.value ?? ""));
            });
            worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
              if (rowNumber === 1) return;
              const rowObj: ExcelRow = {};
              row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                const header = headerCols[colNumber - 1];
                if (header !== undefined) {
                  rowObj[header] =
                    cell.value !== null && cell.value !== undefined
                      ? String(cell.value)
                      : "";
                }
              });
              jsonData.push(rowObj);
            });
          }
        } else {
          const text = new TextDecoder().decode(data);
          const lines = text.split(/\r?\n/).filter((l) => l.trim());
          if (lines.length > 0) {
            headerCols = lines[0]
              .split(",")
              .map((h) => h.trim().replace(/^"|"$/g, ""));
            jsonData = lines.slice(1).map((line) => {
              const values = line
                .split(",")
                .map((v) => v.trim().replace(/^"|"$/g, ""));
              const row: ExcelRow = {};
              headerCols.forEach((h, i) => {
                row[h] = values[i] ?? "";
              });
              return row;
            });
          }
        }
        const seenHeader = new Set();
        for (const header of headerCols) {
          if (seenHeader.has(header)) {
            alert("This file includes duplicate header values.");
            if (fileInputRef.current) {
              fileInputRef.current.value = "";
            }
            return;
          }
          seenHeader.add(header);
        }
        if (jsonData.length > 0) {
          for (const header of headerCols) {
            if (!header || header.trim() === "") {
              alert("This file has blank header columns.");
              if (fileInputRef.current) {
                fileInputRef.current.value = "";
              }
              return;
            }
          }
        } else {
          alert(
            "The file must have a header row and at least one valid row of data."
          );
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
          return;
        }
        setExcelHeaderCols(headerCols);
        const excelData = jsonData.slice(0, 2).map((data) => {
          return headerCols.reduce((obj, headerName) => {
            obj[headerName] = data[headerName] ?? "";
            return obj;
          }, {});
        });
        setExcelData(excelData);
        setValue(
          "rules.importFile.contactListConfiguration.phoneColumns" as keyof IConfiguration,
          [{ columnName: "", type: "", callableTimeColumn: "" }] as any
        );
        setValue(
          "rules.importDNCList.contactListConfiguration.customExclusionColumns" as keyof IConfiguration,
          [] as any
        );
      };

      reader.readAsArrayBuffer(file);
    }
  };
  /**
   * This method is triggerd on selecting radio and it update the selected checkbox value in array
   * @param name name of item in that list
   * @returns void
   */
  const handleAdditionalAttributesRadioChange = (event) => {
    let value = event.target.value;
    if (!event.target.checked) {
      value = "clearAll";
    }
    setSelectedAdditionalAttribute(value);
    const obj = {
      deleteFiles: value === "deleteFiles",
      clearAll: value === "clearAll",
      isMoveFiles: value === "isMoveFiles",
      zipFiles: false,
      encryptFiles: false,
      traceConnection: true,
    };
    if (obj.isMoveFiles === true) {
      obj["moveFiles"] = {
        folderName: watch(
          "serverDetails.additionalAttributes.moveFiles.folderName"
        ),
      };
    } else {
      obj["moveFiles"] = {};
    }
    setValue("serverDetails.additionalAttributes", obj);
  };

  /**
   * This method is used to disable schedule field
   * @param type schedule Type
   */
  const disableScheduleField = (type: "cron" | "manual") => {
    return !watch("schedule") || watch("scheduleDetails.scheduleType") === type;
  };
  /**
   * This method is called when the form is submitted
   * @param data form data
   */
  const handleConfigurationFormSubmit = async (data) => {
    // Convert date to UTC based on selected timezone before saving
    const timezone = data.scheduleDetails.timeZone;
    let convertedDateTime = setOtherZone(watch("scheduleDetails.date") || moment(), timezone);
    const momentObj = moment.utc(convertedDateTime); 
                                

    const configuration = {
      orgId: getStorageItem("organization-id", true, sessionStorage),
      orgName: getStorageItem("organization-name", true, sessionStorage),
      userId: getUserDetails.id,
      user: getUserDetails.name,
      ...data,
      scheduleDetails: {
        ...data.scheduleDetails,
        date: momentObj.format(),
      },
      apiRetrieval: data.apiRetrieval,
      listName: storageType === "API" ? data.listName : undefined,
    };
    
    // Remove apiRetrieval for non-API storage types
    if (storageType !== "API") {
      delete configuration.apiRetrieval;
    }
    configuration.scheduleDetails.isScheduleEventRuleEnabled = true;
    if (!configuration.schedule) {
      setValue("scheduleDetails.cronText", "");
      setValue("scheduleDetails.cron", "");
    } else if (!configuration.scheduleDetails.cron) {
      setCronExpression();
      configuration.scheduleDetails.cron = watch("scheduleDetails.cron");
    }

    if (configuration.rules.ruleType === RulesType.importFile) {
      if (
        configuration.rules.importFile?.appendType === AppendType.newlistsonly
      ) {
        configuration.rules.importFile.contactListConfiguration = {
          attemptLimits: null,
          automaticTimeZoneMapping: false,
          emailColumns: [],
          previewModeAcceptedValues: [],
          previewModeColumnName: "",
          zipCodeColumnName: null,
          ...configuration.rules.importFile.contactListConfiguration,
          columnNames: excelHeaderCols,
        };

        if (
          !watch(
            "rules.importFile.contactListConfiguration.useSpecificationFile"
          )
        ) {
          delete configuration.rules.importFile.fileSpecificationTemplateId;
        }

        if (
          !watch("rules.importFile.contactListConfiguration.useImportTemplate")
        ) {
          delete configuration.rules.importFile.importTemplateId;
          delete configuration.rules.importFile.division;
        } else {
          configuration.rules.importFile.division =
            configuration.rules.importFile.contactListConfiguration.division.id;
          // Delete splitting criteria contact lists for newlistsonly
          delete configuration.rules.importFile.splittingCriteriaContactLists;
          delete configuration.rules.importFile.contactListConfiguration;
        }
      } else if (
        configuration.rules.importFile?.appendType === AppendType.appendonly ||
        configuration.rules.importFile?.appendType === AppendType.flushandappend
      ) {
        if (
          !watch("rules.importFile.contactListConfiguration.useImportTemplate")
        ) {
          delete configuration.rules.importFile.importTemplateId;
          delete configuration.rules.importFile.division;
        } else {
          configuration.rules.importFile.division =
            configuration.rules.importFile.contactListConfiguration.division.id;
          // Add splitting criteria contact lists if they exist
          if (selectedImportTemplate?.useSplittingCriteria && splittingCriteriaContactLists.length > 0) {
            const validLists = splittingCriteriaContactLists.filter(id => id !== "");
            configuration.rules.importFile.splittingCriteriaContactLists = validLists
              .map(id => {
                const contactList = contactListItems.find(item => item.id === id);
                return { id, name: contactList?.name || "" };
              });
            // Add columnNames from first selected contact list
            if (validLists.length > 0) {
              const firstList = contactListItems.find(item => item.id === validLists[0]);
              if (firstList?.columnNames) {
                configuration.rules.importFile.contactListConfiguration.columnNames = firstList.columnNames;
              }
            }
          } else {
            delete configuration.rules.importFile.splittingCriteriaContactLists;
          }
        }
        delete configuration.rules.importFile.contactListConfiguration;
      }
      delete configuration.rules.exportContactList;
      delete configuration.rules.importDNCList;
      delete configuration.rules.exportDNCList;
    } else if (configuration.rules.ruleType === RulesType.exportContactList) {
      configuration.serverDetails.additionalAttributes =
        selectedAdditionalAttributeExport;
      configuration.rules.exportContactList.selectedColumns = selectedExportColumns;
      delete configuration.rules.importFile;
      delete configuration.rules.importDNCList;
      delete configuration.rules.exportDNCList;
    } else if (configuration.rules.ruleType === RulesType.importDNCList) {
      delete configuration.rules.importFile;
      delete configuration.rules.exportDNCList;
      delete configuration.rules.exportContactList;
      if (
        configuration.rules.importDNCList?.appendType ===
        AppendTypeForDNC.newlistsonly
      ) {
        const isInternalDNC = configuration.rules.importDNCList.dncSourceType === DNCSourceType.rds;
        const selectedContactMethod = configuration.rules.importDNCList.contactMethod;
        const dncColumns = configuration.rules.importDNCList.contactListConfiguration?.customExclusionColumns || [];
        
        // Build contact list configuration based on DNC source type
        const contactListConfig: any = {
          contactMethod: isInternalDNC ? selectedContactMethod : "any",
          customExclusionColumn:
            configuration.rules.importDNCList.contactListConfiguration
              .customExclusionColumn,
          division: {
            id: configuration.rules.importDNCList.contactListConfiguration
              .division.id,
          },
          dncSourceType: configuration.rules.importDNCList.dncSourceType || DNCSourceType.rds_custom,
          expirationDateTimeColumn:
            configuration.rules.importDNCList.contactListConfiguration
              .expirationDateTimeColumn,
        };

        // For Internal-Custom (rds_custom), use customExclusionColumns
        // For Internal (rds), use the appropriate column array based on contact method
        if (isInternalDNC && selectedContactMethod) {
          if (selectedContactMethod === DNCContactMethod.phone) {
            contactListConfig.phoneNumberColumns = dncColumns;
          } else if (selectedContactMethod === DNCContactMethod.email) {
            contactListConfig.emailColumns = dncColumns;
          } else if (selectedContactMethod === DNCContactMethod.whatsapp) {
            contactListConfig.whatsAppColumns = dncColumns;
          }
        } else {
          contactListConfig.customExclusionColumns = dncColumns;
        }

        configuration.rules.importFile = {
          appendType: configuration.rules.importDNCList.appendType,
          contactListConfiguration: contactListConfig,
          fileFormatName: configuration.rules.importDNCList.fileFormatName,
          fileFormatOperation:
            configuration.rules.importDNCList.fileFormatOperation,
        };
      } else if (
        configuration.rules.importDNCList?.appendType ===
        AppendTypeForDNC.appendonly
      ) {
        // For append-only, look up the selected DNC list to get its type
        const selectedDncListId = configuration.rules.importDNCList.contactListId;
        const selectedDncList = dncListItems.find(list => list.id === selectedDncListId);
        const listDncSourceType = selectedDncList?.dncSourceType;
        // Normalize contactMethod to lowercase for comparison (API may return "Phone", "Email", etc.)
        const listContactMethod = selectedDncList?.contactMethod?.toLowerCase();
        
        const dncColumns = configuration.rules.importDNCList.contactListConfiguration?.customExclusionColumns || [];

        // Build contact list configuration based on the existing list's type
        const contactListConfigAppend: any = {
          expirationDateTimeColumn:
            configuration.rules.importDNCList.contactListConfiguration
              ?.expirationDateTimeColumn,
          dncSourceType: listDncSourceType,
          contactMethod: listContactMethod || "any",
        };

        // For Internal (rds) type, use the appropriate column array based on contact method
        // For Internal-Custom (rds_custom) or unknown, use customExclusionColumns
        if (listDncSourceType === 'rds' && listContactMethod && listContactMethod !== 'any') {
          if (listContactMethod === DNCContactMethod.phone) {
            contactListConfigAppend.phoneNumberColumns = dncColumns;
          } else if (listContactMethod === DNCContactMethod.email) {
            contactListConfigAppend.emailColumns = dncColumns;
          } else if (listContactMethod === DNCContactMethod.whatsapp) {
            contactListConfigAppend.whatsAppColumns = dncColumns;
          } else {
            // Fallback for any other contact method
            contactListConfigAppend.customExclusionColumns = dncColumns;
          }
        } else {
          contactListConfigAppend.customExclusionColumns = dncColumns;
        }

        configuration.rules.importFile = {
          appendType: configuration.rules.importDNCList.appendType,
          contactListId: configuration.rules.importDNCList.contactListId,
          fileFormatName: configuration.rules.importDNCList.fileFormatName,
          fileFormatOperation:
            configuration.rules.importDNCList.fileFormatOperation,
          contactListConfiguration: contactListConfigAppend,
        };
      }
      delete configuration.rules.importDNCList;
    } else if (configuration.rules.ruleType === RulesType.exportDNCList) {
      configuration.serverDetails.additionalAttributes =
        selectedAdditionalAttributeExport;
      delete configuration.rules.importFile;
      delete configuration.rules.importDNCList;
      delete configuration.rules.exportContactList;
      configuration.rules.exportContactList = {
        campaignId: configuration.rules.exportDNCList.campaignId,
        contactList: configuration.rules.exportDNCList.contactList,
        contactListId: configuration.rules.exportDNCList.contactListId,
        outputFileFormat: "",
      };
      delete configuration.rules.exportDNCList;
    }
    try {
      setFormDataLoading(true);
      configuration.storageType = storageType;
      const queryParams = new URLSearchParams(location.search);
      const response = queryParams.has("jobId")
        ? await updateSftpConfiguration(configuration)
        : await saveSftpConfiguration(configuration);

      const snackDetails = {
        open: true,
        message: <>{response.message}</>,
        severity: "success",
      };

      setSnackDetails(snackDetails);
      navigate(`../${RoutesName.jobsview}`);
      setFormDataLoading(false);
    } catch (err:any) {
      console.error("Configuration Failed : ", err);
      setFormDataLoading(false);
      const errorMessage = err?.message || 'Please try again';
      setSnackDetails({
        open: true,
        message: <>{errorMessage}</>,
        severity: "error",
      });
    }
  };

  /**
   * This method is used hid or display phone col
   * @returns true or false
   */
  const showPhoneMappingCols = () => {
    return phoneFields.length && excelHeaderCols.length ? true : false;
  };

  /**
   * This method is used hid or display dnc col
   * @returns true or false
   */
  const showDNCCols = () => {
    return excelHeaderCols.length ? true : false;
  };

  /**
   * Validate that all selected splitting criteria contact lists have matching columnNames
   */
  const validateSplittingCriteriaColumns = () => {
    const selectedLists = splittingCriteriaContactLists.filter(id => id !== "");
    if (selectedLists.length <= 1) return false;
    
    const firstList = contactListItems.find(item => item.id === selectedLists[0]);
    if (!firstList?.columnNames) return false;
    
    return selectedLists.some(id => {
      const list = contactListItems.find(item => item.id === id);
      return !list?.columnNames || 
             JSON.stringify(list.columnNames.sort()) !== JSON.stringify(firstList.columnNames.sort());
    });
  };

  /**
   *This method is used to disable the form if it invalid
   */
  const disableForm = () => {
    // Check for custom listNameFormat warning for append operations only
    const appendType = watch("rules.importFile.appendType");
    const  useImportTemplate = watch("rules.importFile.contactListConfiguration.useImportTemplate")
    
    // Check if custom file name is enabled but empty
    if (selectedAdditionalAttributeExport.includeCustomFileName && 
        !selectedAdditionalAttributeExport.customFileName?.trim()) {
      return true;
    }
    
    // Check if original contact list name and file name format are required and not filled
    if (useImportTemplate && 
        (appendType === AppendType.appendonly || appendType === AppendType.flushandappend) &&
        (!watch("rules.importFile.originalContactListName") || 
         (storageType === "SFTP" && !watch("rules.importFile.fileFormatName")))) {
      return true;
    }
    
    if (
      watch("rules.ruleType") === RulesType.importFile &&
      watch("rules.importFile.appendType") === AppendType.newlistsonly &&
      watch("rules.importFile.contactListConfiguration.useImportTemplate") ===
        false
    ) {
      return !isValid || !showPhoneMappingCols();
    }
    
    // Check if splitting criteria is enabled and at least one contact list is selected
    if (
      selectedImportTemplate?.useSplittingCriteria &&
      (watch("rules.importFile.appendType") === AppendType.appendonly ||
       watch("rules.importFile.appendType") === AppendType.flushandappend)
    ) {
      const hasValidContactList = splittingCriteriaContactLists.some(id => id !== "");
      const hasColumnMismatch = validateSplittingCriteriaColumns();
      // For API storage, skip isValid check (has irrelevant SFTP field validations)
      if (storageType === "API") {
        return !hasValidContactList || hasColumnMismatch;
      }
      return !isValid || !hasValidContactList || hasColumnMismatch;
    }
    
    // Check if splitting criteria is disabled and no contact list is selected
    if (
      !selectedImportTemplate?.useSplittingCriteria &&
      (watch("rules.importFile.appendType") === AppendType.appendonly ||
       watch("rules.importFile.appendType") === AppendType.flushandappend) &&
      !watch("rules.importFile.contactList")
    ) {
      return true;
    }
    return !isValid;
  };

  /**
   *This method is used to handle port validation
   */
   const handlePortChange = e => {
    let portError = false;
    let port = Number(e.target.value);
    if (isNaN(port)) {
      portError = true;
    }   
    // Check if it's within the valid port range (1 to 65535)
    portError = !(port >= 1 && port <= 65535);  
    setPortError(portError);
    if (!portError) {
      setValue("serverDetails.port", e.target.value);
    } 
  };

  /**
   * This method is used to test the sftp creds
   */
  const resolveServerHost = (fileServerValue: string | null): string => {
    const match = getServerList.find((opt: any) => opt.id === fileServerValue) ||
                  getServerList.find((opt: any) => opt.serverName === fileServerValue);
    return match?.serverName || fileServerValue || "";
  };

  const testConnectionHandler = async () => {
    const resolvedHost = resolveServerHost(watch("serverDetails.fileServer"));
    let body: any = {
      host: resolvedHost,
      port: watch("serverDetails.port"),
      username: watch("serverDetails.userName") || "",
      type: watch("serverDetails.authenticationType") || "",
    };

    if (
      watch("serverDetails.authenticationType") ===
        AuthenticationType.password ||
      watch("serverDetails.authenticationType") ===
        AuthenticationType.sshandpassword
    ) {
      body = {
        host: resolvedHost,
        port: watch("serverDetails.port"),
        username: watch("serverDetails.userName") || "",
        password: watch("serverDetails.password") || "",
        type: watch("serverDetails.authenticationType") || "",
      };
      if (body.host === "" || body.username === "" || body["password"] === "") {
        setSnackDetails({
          open: true,
          message: <>Enter Creds</>,
          severity: "error",
        });
        return;
      }
    } else {
      if (body.host === "" || body.username === "") {
        setSnackDetails({
          open: true,
          message: <>Enter Creds</>,
          severity: "error",
        });
        return;
      }
    }
    setFormDataLoading(true);
    try {
      const sftpConnectionValidity = await testConnection(body);
      setIsSFTPCredsValid(
        sftpConnectionValidity.message === "Connection successful!"
      );
      setSnackDetails({
        open: true,
        message: (
          <>
            {sftpConnectionValidity.message === "Connection successful!"
              ? "Test Connection is Successful"
              : "Invalid Credentials"}
          </>
        ),
        severity:
          sftpConnectionValidity.message === "Connection successful!"
            ? "success"
            : "error",
      });
      setFormDataLoading(false);
    } catch (err: any) {
      setSnackDetails({
        open: true,
        message: <>{err.message || "Invalid Credentials or Connection Failed"}</>,
        severity: "error",
      });
      setIsSFTPCredsValid(false);
      setFormDataLoading(false);
    }
  };

  /**
   * This method is used to set the cron expression on change of date
   */
  const setCronExpression = () => {

    // Below code is commented since DateTime UI component is containing the correct time zone values


    // // const date = moment.utc(watch("scheduleDetails.date") || moment());
    // let date = moment(watch("scheduleDetails.date") || moment());
  
    // /// fix for different timezone selection
    // let convertedDateTime = setOtherZone(watch("scheduleDetails.date") || moment(), tzone);
    // console.log("converted date", convertedDateTime.toUTCString())
    // const momentObj = moment.utc(convertedDateTime); // Creates a Moment object representing October 26, 2023, 10:00 AM with a -08:00 offset
    // console.log(momentObj.format());

    
    let selectedDate = watch("scheduleDetails.date") || moment();
    const tzone = watch("scheduleDetails.timeZone")  
    console.log("selectedDate", selectedDate.format(), "tzone", tzone);
    let date = moment.tz(selectedDate, tzone || 'UTC');
    console.log("date after timezone conversion", date.format());
    const momentObj = moment.utc(date); // Creates a Moment object representing the selected date in UTC
    console.log("momentObj", momentObj.format());
    // Check if DST is enabled
    let day,month, minutes, hours;
    if (!isDSTEnabled){
      day = parseInt(momentObj.format("DD"), 10) ; // Adjust day for non-DST
      month = parseInt(momentObj.format("MM"), 10); // Adjust month for non-DST 
      minutes = parseInt(momentObj.format("mm"), 10); // Extract minutes as number
      hours = parseInt(momentObj.format("HH"), 10); // Extract hours as number
    } 
    else {
      day = parseInt(date.format("DD"), 10); // Extract day as number
      month = parseInt(date.format("MM"), 10); // Extract month as number
      minutes = parseInt(date.format("mm"), 10); // Extract minutes as number
      hours = parseInt(date.format("HH"), 10); // Extract hours as number
    }


    const cronExp = minutes + " " + hours + " " + day + " " + month + " ? *";
    const cronExpForText =
      minutes + " " + hours + " " + day + " " + (month - 1) + " ? *";
    setValue(
      "scheduleDetails.cronText",
      cronstrue.toString(cronExpForText as string, {
        verbose: true,
        monthStartIndexZero: true,
      })
    );
    setValue("scheduleDetails.cron", cronExp);
  };

  /**
   * This method is triggered when save button is select in scheduler dialog and data from dialog box is updated in main form
   * @param data scheduler dialog data like as given in IScheduled interface
   * @returns void
   */
  const handleSchedulerDialogSaveData = (data: IScheduledTask): void => {
    setValue("scheduleDetails.description", data.description || "");
    // The schedule date is removed from the recurring task dialog so the date settings not necessary
    // setValue("scheduleDetails.date", moment(data.startDate));
    //setHumanReadableText(data.cronWordExp as string);
    const text: string = cronstrue.toString(data.cronExpression as string, {
      verbose: true,
      monthStartIndexZero: true,
    });
    setValue("scheduleDetails.cronText", text);
    setValue("scheduleDetails.cron", data.cronExpression as string);
    setSchedulerDialogOpen(false);
  };

  /**
   *This method is used evaluate cron express is less than 5 mins or not
   * @param cronExpression cron expression
   * @returns true if it is less than 5 mins else false
   */
  const isCronExpressionLessThan5Minutes = (cronExpression) => {
    // Split the expression into its fields
    const fields = cronExpression.split(" ");
    
    // Parse the minutes field (first field)
    const minutesField = fields[0];

    // Check if the minutes field allows the expression to run more frequently than every 5 minutes
    if (minutesField === "*") {
      return true; // Runs every minute, which is less than 5 minutes
    }

    // Split the minutes field into its elements (comma-separated values)
    const minuteElements = minutesField.split(",");

    // Check each element for ranges and steps
    for (const element of minuteElements) {
      if (element.includes("/")) {
        // If the element contains a step, extract the step value and check if it's less than 5
        const stepValue = parseInt(element.split("/")[1]);
        if (stepValue < 5) {
          return true; // Runs more frequently than every 5 minutes
        }
      } else if (element.includes("-")) {
        // If the element contains a range, extract the start and end values
        const [start, end] = element.split("-");
        const startValue = parseInt(start);
        const endValue = parseInt(end);
        
        // Check if consecutive values in the range would run less than 5 minutes apart
        if (endValue - startValue < 5) {
          return true; // Runs more frequently than every 5 minutes
        }
      }
      // Single values like "0" mean "run at minute 0 of each hour" which is not less than 5 minutes
    }
    
    return false; // Does not run more frequently than every 5 minutes
  };

  /**
   *This method is used to check if cron expression has minutes 60 or greater
   * @param cronExpression cron expression
   * @returns true if minutes are 60 or greater else false
   */
  const isCronExpressionMinutes60OrGreater = (cronExpression) => {
    // Split the expression into its fields
    const fields = cronExpression.split(" ");
    
    // Parse the minutes field (first field)
    const minutesField = fields[0];

    if (minutesField === "*") {
      return true; 
    }

    // Split the minutes field into its elements (comma-separated values)
    const minuteElements = minutesField.split(",");

    // Check each element for ranges and steps
    for (const element of minuteElements) {
      if (element.includes("/")) {
        const stepValue = parseInt(element.split("/")[1]);
        if (stepValue >= 60) {
          return true; 
        }
      } else if (element.includes("-")) {
        // If the element contains a range, extract the start and end values
        const [start, end] = element.split("-");
        const startValue = parseInt(start);
        const endValue = parseInt(end);
        
        if (endValue - startValue >=60) {
          return true; 
        }
      }
    }
  };

  /**
   * This method is used to check whether the cron expression is correct or not and converts into human readable form
   */
  const handleCronExpression = () => {
    try {
      const cronExp = watch("scheduleDetails.cron");
      awsCronExpressionValidator(cronExp);
      const str = cronExp?.toString();
      const text: string = cronstrue.toString(str as string, {
        verbose: true,
        // monthStartIndexZero: true,
      });
      if (isCronExpressionLessThan5Minutes(str)) {
        setError("scheduleDetails.cron", {
          type: "manual",
          message: "Invalid CRON Expression.",
        });
        setValue("scheduleDetails.cronText", "Invalid CRON Expression");
        return;
      }
      if (isCronExpressionMinutes60OrGreater(str)) {
        setError("scheduleDetails.cron", {
          type: "manual",
          message: "Invalid CRON Expression.",
        });
        setValue("scheduleDetails.cronText", "Invalid CRON Expression. Change 0/60 to 0.");
        return;
      }
      setValue("scheduleDetails.cronText", text);
    } catch (err) {
      setError("scheduleDetails.cron", {
        type: "manual",
        message: "Invalid CRON Expression.",
      });
      setValue("scheduleDetails.cronText", "Invalid CRON Expression");
    }
  };

  // This method is used to download the public key for ssh
  const handlePublicKeyDownload = () => {
    // Creating a blob with MIME type 'text/plain'
    const file = new Blob([getPublicKeyDetails.publicKey], {
      type: "text/plain",
    });

    // Creating a temporary link to trigger the download
    const element = document.createElement("a");
    element.href = URL.createObjectURL(file);
    element.download = "publicKey.pub"; // Setting the file name for the download

    // Triggering the download
    element.click();

    // Optional: releasing the blob URL object after the download to free up resources
    URL.revokeObjectURL(element.href);
  };

  const setOtherZone = (date, timezone) => {
    const dateWithoutZone = moment(date).format("YYYY-MM-DDTHH:mm:ss.SSS")
    const otherZone = moment.tz(date, timezone || 'UTC').format("Z")
    const dateWithOtherZone = [dateWithoutZone, otherZone].join("")
  
    return new Date(dateWithOtherZone)
  }

  return (
    <Paper className="configuration">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isFormDataLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <form onSubmit={handleSubmit(handleConfigurationFormSubmit)}>
        <div className="row">
          <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <span className="px-1 d-flex align-items-center text">
              <InfoOutlinedIcon /> All fields marked with an asterisk(*) are
              required
            </span>
            <div className="mt-3 mb-2 d-flex">
              <TextField
                label="Automation Name *"
                {...register("automationName", {
                  required: true,
                })}
                value={watch("automationName")}
                variant="outlined"
                size="small"
                sx={{ width: "50%", padding: "0px 5px" }}
                error={!!errors.automationName}
                helperText={errors.automationName?.message}
              />
              <TextField
                label="Automation Description"
                {...register("automationDescription")}
                value={watch("automationDescription")}
                variant="outlined"
                size="small"
                sx={{ width: "50%", padding: "0px 5px" }}
              />
            </div>

            <section className="mt-3 mb-2">
              <Tabs value={selectedTab} onChange={
                (event: React.SyntheticEvent, newValue: number) => {
                  setSelectedTab(newValue);
                }
              }>
                <Tab label="Schedule" />
                <Tab label="Notification" />
              </Tabs>
              {selectedTab == 0 && <Box>
              <div className="m-2 text">
                Schedule
                <Switch
                  size="small"
                  // {...register("schedule")} || This causing automatic re-rendering issue. When tab switched it rolls back to false
                  checked={watch("schedule")}
                  disabled={getDisableSchedule}
                  onChange={() => {
                    setValue("schedule", !watch("schedule"));
                    setValue("scheduleDetails.cron", "");
                    setValue("scheduleDetails.cronText", "");
                  }}
                />
              </div>
              <Paper
                elevation={2}
                sx={{
                  margin: "10px 5px 5px 5px",
                  padding: "10px",
                   flex: 1
                }}
              >
                <FormControl component="fieldset" sx={{ width: "100%" }}>
                  <div className="row">
                    <div className="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1">
                      </div>
                      <div className="col-11 col-sm-11 col-md-11 col-lg-11 col-xl-11">
                      
                      <div className="d-flex justify-content-between">
                    <Controller
                        name="scheduleDetails.timeZone"
                        control={control}
                        render={({ field }) => (
                          <Autocomplete
                            disablePortal
                            disabled={!watch("schedule")}
                            size="small"
                            sx={{ marginTop: "10px", width: "100%" }}
                            options={momentTimeZone.tz.names()}
                            {...field}
                            value={watch("scheduleDetails.timeZone")}
                            onChange={(_event, newValue) => {
                              setValue(
                                "scheduleDetails.timeZone",
                                newValue as string
                              );

                              // When date is changed, we find the UTC date and set it in the form 
                              // with the selected time zone
                              // This is to ensure that the date is always in the correct time zone 
                              let scheduleDate = watch("scheduleDetails.date") || moment();
                              let selectedDate = scheduleDate.format();
                              var newTimeValue = moment.tz(selectedDate, "YYYY-MM-DDTHH:mm:ss", watch("scheduleDetails.timeZone") || 'UTC');
                              console.log("DATE - PARSED VALUE:", newTimeValue.format()); // 2025-04-18T14:00:34Z
                              console.log("DATE - PARSED VALUE - UTC:",  moment.tz(selectedDate,"UTC" ).format()); // 2025-04-18T14:00:34Z
                              setValue("scheduleDetails.date", newTimeValue!);
                              setCronExpression();
                              }
                            }
                            renderInput={(params) => (
                              <TextField {...params} label="Time Zone *" />
                            )}
                          />
                        )}
                      />
                      </div>
                    </div>
                    {/* Manual Option */}
                    <div className="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1" style={{ paddingTop: "30px" }}>
                      <Radio
                        checked={
                          watch("scheduleDetails.scheduleType") === "manual"
                        }
                        onChange={() =>
                          setValue("scheduleDetails.scheduleType", "manual")
                        }
                        value="manual"
                        disabled={!watch("schedule")}
                      />
                    </div>
                    {/* Manual Controls */}
                    <div className="col-11 col-sm-11 col-md-11 col-lg-11 col-xl-11" style={{ paddingTop: "20px" }}>
                      
                      <div className="d-flex justify-content-between">
                        <Controller
                          control={control}
                          name="scheduleDetails.date"
                          rules={{
                            required: "Schedule Date is required",
                          }}
                          render={({ field }) => (
                            <DateTimePicker
                              {...field}
                              label="Schedule Date"
                              views={[
                                "year",
                                "month",
                                "day",
                                "hours",
                                "minutes"
                              ]}
                              viewRenderers={{
                                hours: renderTimeViewClock,
                                minutes: renderTimeViewClock
                              }}
                              // minDate={moment()} // Set the minimum date to the current date
                              sx={{ width: "60%" }}
                              disabled={disableScheduleField("cron")}
                              onChange={(date) => {
                                // Update the form value using setValue
                                let selectedDate = date!.format(); 
                                var b = moment.tz(selectedDate, "YYYY-MM-DDTHH:mm:ss", watch("scheduleDetails.timeZone") || 'UTC');
                                console.log("DATE - PARSED VALUE:", b.format()); // 2025-04-18T14:00:34Z
                                console.log("DATE - PARSED VALUE - UTC:",  moment.tz(selectedDate,"UTC" ).format()); // 2025-04-18T14:00:34Z
                                setValue("scheduleDetails.date", b!);
                                scheduledDate.current = date!.format();
                                setCronExpression();
                              }}
                            />
                          )}
                        />
                        <div className="m-2 text-500">
                          Recurrence
                          <IconButton
                            disabled={disableScheduleField("cron")}
                            onClick={() => setSchedulerDialogOpen(true)}
                          >
                            <AddCircleOutlineIcon />
                          </IconButton>
                          <SchedulerDialog
                            dailogOpen={isSchedulerDialogOpen}
                            handleClose={() => setSchedulerDialogOpen(false)}
                            schedulerData={{
                              startDate: watch("scheduleDetails.date"),
                              description: watch("scheduleDetails.description"),
                            }}
                            isDSTEnabled={isDSTEnabled}
                            toSaveData={handleSchedulerDialogSaveData}
                            templateName={
                              watch("scheduleDetails.timeZone") || ""
                            }
                            isUpdate={false}
                          />
                        </div>
                      </div>
                      <TextField
                        {...register("scheduleDetails.description")}
                        label="Description"
                        multiline
                        rows={4}
                        value={watch("scheduleDetails.description") || ""}
                        disabled={disableScheduleField("cron")}
                        sx={{ width: "100%", marginTop: "30px" }}
                      />
                    </div>
                    {/* Cron Option */}
                    <div className="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1">
                      <Radio
                        checked={
                          watch("scheduleDetails.scheduleType") === "cron"
                        }
                        onChange={() =>
                          setValue("scheduleDetails.scheduleType", "cron")
                        }
                        value="cron"
                        disabled={!watch("schedule")}
                      />
                    </div>
                    {/* Cron Controls */}
                    <div className="col-11 col-sm-11 col-md-11 col-lg-11 col-xl-11">
                      <TextField
                        {...register("scheduleDetails.cron")}
                        label="Cron"
                        size="small"
                        value={watch("scheduleDetails.cron") || ""}
                        disabled={disableScheduleField("manual")}
                        onBlur={handleCronExpression}
                        error={!!errors["scheduleDetails.cron"]}
                        sx={{ width: "100%", marginTop: "10px" }}
                      />
                      <p>Note: cron expression below 5 mins are not allowed</p>
                        <p style={{ color: watch("scheduleDetails.cronText")?.includes("Invalid CRON Expression") ? "red" : "inherit" }}>
                          {watch("scheduleDetails.cronText")} { !isDSTEnabled && <span> (UTC) </span> }
                        </p>
                    </div>
                  </div>
                </FormControl>
              </Paper>
              </Box>}
              {selectedTab == 1 && (
                <Box>
                  <Paper
                    elevation={2}
                    sx={{
                      margin: "10px 5px 5px 5px",
                      padding: "10px",
                      minHeight: 445,
                    }}
                  >
                    {/* Switch component to enable custom notification */}
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="text">Custom Notification</div>
                      <Switch
                        size="small"
                        {...register("customNotification")}
                        checked={!!watch("customNotification")}
                        onChange={() => {
                          setValue("customNotification", !watch("customNotification"));
                        }}
                      />
                    </div>

                    {/* Email listing component */}
                    <div className="mt-3">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="text">Notification Emails</div>
                        <Button
                          variant="contained"
                          size="small"
                          disabled={!watch("customNotification")}
                          onClick={handleAddEmail}
                        >
                          Add Email
                        </Button>
                      </div>
                      <div className="mt-2">
                        {customNotificationEmail.map((email, index) => (
                          <div key={index} className="d-flex align-items-center mb-2">
                            <TextField
                              size="small"
                              value={email}
                              onChange={(e) => handleEmailChange(index, e.target.value)}
                              disabled={!watch("customNotification")}
                              sx={{ flex: 1, marginRight: "10px" }}
                              placeholder="Enter email"
                              error={!!emailErrors[index]}
                              helperText={emailErrors[index]}
                            />
                            <Button
                              variant="outlined"
                              size="small"
                              color="error"
                              disabled={!watch("customNotification")}
                              onClick={() => handleRemoveEmail(index)}
                            >
                              Remove
                            </Button>
                          </div>
                        ))}
                      </div>
                    </div>
                  </Paper>
                </Box>
              )}
            </section>
          </div>
          <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <section className="mt-3 mb-2 source-tabs" style={{ height: "100%", display: "flex", flexDirection: "column" }}>            
              {storageType === "SFTP" && (
                <Paper
                  elevation={2}
                  sx={{
                    margin: "10px 5px 5px 5px",
                    padding: "10px",
                    flex: 1,
                  }}
                >
                  <Typography variant="h6" className="text">
                    SFTP Configuration
                  </Typography>
                  <TextField
                    {...register("serverDetails.userName", { required: true })}
                    label="User Name *"
                    value={watch("serverDetails.userName") || ""}
                    variant="outlined"
                    size="small"
                    disabled={prefilledServer}
                    error={!!errors?.serverDetails?.userName}
                    sx={{ marginTop: "10px", width: "100%" }}
                  />
                  <section>
                    <div className="mtw-30 text">Authenticate Using</div>

                <div className="d-flex justify-content-center">
                  <Controller
                    name="serverDetails.authenticationType"
                    control={control}
                    render={({ field }) => (
                      <ToggleButtonGroup {...field} size="small" exclusive disabled={prefilledServer}>
                        <ToggleButton value={AuthenticationType.password}>
                          Password
                        </ToggleButton>
                        <ToggleButton value={AuthenticationType.ssh}>
                          SSH Key
                        </ToggleButton>
                        <ToggleButton value={AuthenticationType.sshandpassword}>
                          SSH Key and Password
                        </ToggleButton>
                      </ToggleButtonGroup>
                    )}
                  />
                </div>
                {watch("serverDetails.authenticationType") ===
                  AuthenticationType.password && (
                  <div className="mtw-30 d-flex">
                    <TextField
                    {...register("serverDetails.password", {
                      required: true,
                    })}
                    label="Password *"
                    value={watch("serverDetails.password") || ""}
                    variant="outlined"
                    size="small"
                    type="password"
                    disabled={prefilledServer}
                    error={!!errors?.serverDetails?.password}
                    sx={{ width: "100%", padding: "0px 5px" }}
                  />
                  </div>
                )}
                {watch("serverDetails.authenticationType") ===
                  AuthenticationType.ssh && (
                  <div className="mtw-30 d-flex justify-content-center">
                    <Button
                      variant="contained"
                      size="medium"
                      sx={{ color: "white", backgroundColor: "#1b2c48" }}
                      onClick={handlePublicKeyDownload}
                    >
                      Download Key
                    </Button>
                  </div>
                )}

                {watch("serverDetails.authenticationType") ===
                  AuthenticationType.sshandpassword && (
                  <div className="mtw-30 d-flex justify-content-between">
                    <TextField
                    {...register("serverDetails.password", {
                      required: true,
                    })}
                    label="Password *"
                    value={watch("serverDetails.password") || ""}
                    variant="outlined"
                    size="small"
                    type="password"
                    disabled={prefilledServer}
                    error={!!errors?.serverDetails?.password}
                    sx={{ width: "70%", padding: "0px 5px" }}
                  />
                    <Button
                      variant="contained"
                      size="medium"
                      sx={{ color: "white", backgroundColor: "#1b2c48" }}
                      onClick={handlePublicKeyDownload}
                    >
                      Download Key
                    </Button>
                  </div>
                )}
                <div className="mtw-30 d-flex">
                  <Controller
                    name="serverDetails.fileServer"
                    control={control}
                    render={({ field }) => (
                      <Autocomplete
                        disablePortal
                        size="small"
                        sx={{ width: "50%", padding: "0px 5px" }}
                        options={getServerList}
                        getOptionLabel={(option: any) => option?.serverName || ""}
                        isOptionEqualToValue={(option: any, value: any) => option?.id === value?.id}
                        {...field}
                        value={
                          getServerList.find(
                            (opt: any) => opt.id === watch("serverDetails.fileServer")
                          ) ||
                          getServerList.find(
                            (opt: any) => opt.serverName === watch("serverDetails.fileServer")
                          ) || null
                        }
                        renderOption={(props, option: any) => (
                          <li {...props} key={option.id} style={{ display: 'block', padding: '8px 16px' }}>
                            <div>{option.serverName}</div>
                            {!option.isLegacy && option.userName && (
                              <div style={{ fontSize: '0.75rem', color: '#666', marginTop: '4px' }}>User: {option.userName}</div>
                            )}
                          </li>
                        )}
                        onChange={(_event, newValue: any) => {
                          // If previous selection was a new-format server, clean the form fields
                          const previousId = watch("serverDetails.fileServer");
                          const previousOpt = getServerList.find((opt: any) => opt.id === previousId);
                          if (previousOpt && !previousOpt.isLegacy) {
                            setValue("serverDetails.port", 22);
                            setValue("serverDetails.userName", "");
                            setValue("serverDetails.password", "");
                          }

                          // Store id as the fileServer value
                          setValue("serverDetails.fileServer", newValue?.id || null);

                          if (newValue && !newValue.isLegacy) {
                            setValue("serverDetails.port", newValue.port);
                            setValue("serverDetails.userName", newValue.userName);
                            setValue("serverDetails.password", newValue.password);
                            setValue("serverDetails.authenticationType", newValue.authType);
                            setValue("serverDetails.publicKey", newValue.publicKey);
                            setPreFilledServer(true);
                          } else {
                            setPreFilledServer(false);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="File Server *" />
                        )}
                      />
                    )}
                  />
                  <TextField
                    {...register("serverDetails.directory", {
                      required: true,
                    })}
                    label="Directory *"
                    value={watch("serverDetails.directory")}
                    variant="outlined"
                    size="small"
                    error={!!errors?.serverDetails?.directory}
                    sx={{ width: "50%", padding: "0px 5px" }}
                  />                  
                </div>
                <div className="mtw-30 d-flex">                  
                   <TextField
                    {...register("serverDetails.port", {
                      required: true,
                    })}
                    label="Port"
                    value={watch("serverDetails.port")}
                    variant="outlined"
                    size="small"
                    error={!!errors?.serverDetails?.port}
                    disabled={prefilledServer}
                    onChange={handlePortChange}                    
                    helperText={portError ? "{Please enter a valid port number}" : ""}
                  />
                </div>
                {(watch("serverDetails.authenticationType") ===
                  AuthenticationType.sshandpassword ||
                  watch("serverDetails.authenticationType") ===
                    AuthenticationType.ssh) && (
                  // <TextField
                  //   {...register("serverDetails.publicKey", {
                  //     required: true,
                  //   })}
                  //   label="Public Key *"
                  //   value={watch("serverDetails.publicKey")}
                  //   variant="outlined"
                  //   size="small"
                  //   error={!!errors?.serverDetails?.publicKey}
                  //   sx={{
                  //     width: "100%",
                  //     padding: "0px 5px",
                  //     marginTop: "30px",
                  //   }}
                  // />
                  <TextField
                    label="Fingerprint"
                    value={getPublicKeyDetails.fingerprint}
                    variant="outlined"
                    size="small"
                    disabled={true}
                    sx={{
                      width: "100%",
                      padding: "0px 5px",
                      marginTop: "30px",
                    }}
                  />
                )}
              </section>
              <div className="d-flex justify-content-between align-items-end">
                <FormControl
                  sx={{ marginTop: "10px", width: "60%" }}
                  component="fieldset"
                  variant="standard"
                  size="small"
                >
                  <FormGroup>
                    {[RulesType.importFile, RulesType.importDNCList].includes(
                      watch("rules.ruleType")
                    ) && (
                      <RadioGroup
                        aria-label="additionalAttributes"
                        name="additionalAttributes"
                        value={selectedAdditionalAttribute}
                        onChange={handleAdditionalAttributesRadioChange}
                      >
                        <FormControlLabel
                          value="clearAll"
                          control={<Radio />}
                          label="None"
                        />
                        <FormControlLabel
                          value="deleteFiles"
                          control={<Radio />}
                          label="Delete Files after import"
                        />
                        <FormControlLabel
                          value="isMoveFiles"
                          control={<Radio />}
                          label="Move Files after import"
                        />
                        {selectedAdditionalAttribute === "isMoveFiles" && (
                          <Controller
                            name="serverDetails.additionalAttributes.moveFiles.folderName"
                            control={control}
                            defaultValue={watch(
                              "serverDetails.additionalAttributes.moveFiles.folderName"
                            )}
                            rules={{ required: "Folder Name is required" }}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Folder Name *"
                                variant="outlined"
                                size="small"
                                error={
                                  !!errors?.serverDetails?.additionalAttributes
                                    ?.moveFiles?.folderName
                                }
                                sx={{ width: "100%", padding: "5px 5px" }}
                              />
                            )}
                          />
                        )}
                      </RadioGroup>
                    )}
                    {[
                      RulesType.exportContactList,
                      RulesType.exportDNCList,
                    ].includes(watch("rules.ruleType")) && (
                      <>
                        <FormControlLabel
                          value="zipFiles"
                          control={
                            <Checkbox
                              onChange={(_e, checked) => {
                                setSelectedAdditionalAttributeExport({
                                  ...selectedAdditionalAttributeExport,
                                  zipFiles: checked,
                                });
                                setValue("serverDetails.additionalAttributes", {
                                  ...selectedAdditionalAttributeExport,
                                  zipFiles: checked,
                                });
                              }}
                            />
                          }
                          label="Zip files"
                          checked={selectedAdditionalAttributeExport.zipFiles}
                        />
                        <FormControlLabel
                          value="encryptFiles"
                          control={
                            <Checkbox
                              onChange={(_e, checked) => {
                                setSelectedAdditionalAttributeExport({
                                  ...selectedAdditionalAttributeExport,
                                  encryptFiles: checked,
                                });
                                setValue("serverDetails.additionalAttributes", {
                                  ...selectedAdditionalAttributeExport,
                                  encryptFiles: checked,
                                });
                              }}
                            />
                          }
                          disabled={!canWeEncryptExportOperation}
                          label="Encrypt files"
                          checked={
                            selectedAdditionalAttributeExport.encryptFiles
                          }
                        />
                      </>
                    )}
                  </FormGroup>
                </FormControl>
                <div>
                  <Button
                    variant="contained"
                    size="medium"
                    sx={{ color: "white", backgroundColor: "#1b2c48" }}
                    onClick={testConnectionHandler}
                  >
                    Test Connection
                  </Button>
                </div>
              </div>
                </Paper>
              )}
              { (storageType === "AWS-S3" || storageType == 'API') && (
                <Paper elevation={2} sx={{margin: "10px 5px 5px 5px",padding: "10px",minHeight: 543, flex: 1, display: "flex", flexDirection: "column"}}>
                  {storageType == 'API' && <ApiRetrieval
                    control={control as Control<any>}
                    setValue={setValue}
                    watch={watch}
                    setSnackDetails={setSnackDetails}
                    setFormDataLoading={setFormDataLoading}
                  />}
                  {storageType == 'AWS-S3' && <S3Storage
                    register={register}
                    control={control}
                    setValue={setValue}
                    watch={watch}
                    setSnackDetails={setSnackDetails}
                    setFormDataLoading={setFormDataLoading}
                    serverList={getServerList}
                    selectedAdditionalAttribute={selectedAdditionalAttribute}
                    setSelectedAdditionalAttribute={setSelectedAdditionalAttribute}
                    handleAdditionalAttributesRadioChange={handleAdditionalAttributesRadioChange}
                  />}
                </Paper>
              )}
            </section>
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div className="m-2 text"></div>
            <Paper
              elevation={2}
              sx={{ margin: "10px 5px 5px 5px", padding: "10px" }}
            >
              <Controller
                name="rules.ruleType"
                control={control}
                render={({ field }) => (
                  <RadioGroup row {...field} value={watch("rules.ruleType")}>
                    <FormControlLabel
                      value={RulesType.importFile}
                      control={<Radio />}
                      label="Import Contact List"
                    />
                    {storageType !== "API" && (
                      <FormControlLabel
                        value={RulesType.exportContactList}
                        control={<Radio />}
                        label="Export Contact List"
                      />
                    )}
                    <FormControlLabel
                      value={RulesType.importDNCList}
                      control={<Radio />}
                      label="Import DNC List"
                    />
                    {storageType !== "API" && (
                      <FormControlLabel
                        value={RulesType.exportDNCList}
                        control={<Radio />}
                        label="Export DNC List"
                      />
                    )}
                  </RadioGroup>
                )}
              />
              <div className="row">
                {watch("rules.ruleType") === RulesType.importFile && (
                  <>
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 mt-30">
                      <FormControl sx={{ width: "100%" }} size="small">
                        <InputLabel id="demo-select-small-label">
                          File Format Operation
                        </InputLabel>
                        <Select
                          {...register("rules.importFile.fileFormatOperation", {
                            required: storageType !== "API",
                          })}
                          label="File Format Operation"
                           disabled={storageType === "API"}
                          value={
                            watch("rules.importFile.fileFormatOperation") || ""
                          }
                        >
                          {FileFormatOperationTypeList.map((list, i) => (
                            <MenuItem value={list.value} key={i}>
                              {list.displayName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                     {storageType === "API" ? (
                      <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 mt-30">
                        <TextField
                          label="List name *"
                          {...register("listName" as any, {
                            required: watch("rules.importFile.appendType") === AppendType.newlistsonly,
                          })}
                          value={watch("listName" as any) || ""}
                          variant="outlined"
                          size="small"
                          disabled={watch("rules.importFile.appendType") === AppendType.appendonly || watch("rules.importFile.appendType") === AppendType.flushandappend}
                          sx={{ width: "100%", padding: "0px 5px" }}
                        />
                      </div>
                    ) : (
                      <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 mt-30">
                        <TextField
                          label="File name format *"
                          {...register("rules.importFile.fileFormatName", {
                            required: true,
                          })}
                          value={watch("rules.importFile.fileFormatName") || ""}
                          variant="outlined"
                          size="small"
                          sx={{ width: "100%", padding: "0px 5px" }}
                        />
                      </div>
                    )}
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 mt-30">
                      <Controller
                        name="rules.importFile.contactList"
                        control={control}
                        rules={{
                          required:
                            watch("rules.importFile.appendType") !==
                            AppendType.newlistsonly &&
                            !(selectedImportTemplate && selectedImportTemplate?.useSplittingCriteria === true)
                              ? "Contact List is required"
                              : false,
                        }}
                        render={({ field }) => (
                          <Autocomplete
                            disablePortal
                            size="small"
                            disabled={
                              watch("rules.importFile.appendType") ===
                              AppendType.newlistsonly ||
                              selectedImportTemplate?.useSplittingCriteria
                            }
                            sx={{ width: "100%", padding: "0px 5px" }}
                            options={contactListItems}
                            getOptionLabel={(option) => option.name}
                            {...field}
                            value={
                              contactListItems.find(
                                (contact) =>
                                  contact.name ===
                                  watch("rules.importFile.contactList")
                              ) || null
                            }
                            onChange={(_event, newValue) => {
                              if (newValue) {
                                setContactListColumns(newValue.columnNames)
                              } else {
                                setContactListColumns([])
                              }
                              setValue(
                                "rules.importFile.contactIdName" as keyof IConfiguration,
                                "",
                                { shouldDirty: true, shouldValidate: true }
                              );
                              setValue(
                                "rules.importFile.contactListId" as keyof IConfiguration,
                                newValue?.id,
                                { shouldDirty: true, shouldValidate: true }
                              );
                              setValue(
                                "rules.importFile.phoneColumns" as keyof IConfiguration,
                                newValue?.phoneColumns,
                                { shouldDirty: true, shouldValidate: true }
                              );
                              setValue(
                                "rules.importFile.contactList" as keyof IConfiguration,
                                newValue?.name as string,
                                { shouldDirty: true, shouldValidate: true }
                              );
                            }}
                            renderInput={(params) => (
                              <TextField {...params} label="Contact List *" />
                            )}
                          />
                        )}
                      />
                    </div>
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 mt-30">
                      <FormControl
                        sx={{ width: "100%", padding: "0px 5px" }}
                        size="small"
                      >
                        <Controller
                          name="rules.importFile.appendType"
                          control={control}
                          rules={{
                            required: "Append Type is required",
                          }}
                          render={({ field }) => (
                            <Autocomplete
                              disablePortal
                              size="small"
                              sx={{ width: "100%", padding: "0px 5px" }}
                              {...field}
                              options={AppendTypeList}
                              getOptionLabel={(option) => option.displayName}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  label="Append Type *"
                                />
                              )}
                              value={
                                AppendTypeList.find(
                                  (appendType) =>
                                    appendType.value ===
                                    watch("rules.importFile.appendType")
                                ) || null
                              }
                              onChange={(_, newValue) => {
                                setValue(
                                  "rules.importFile.appendType" as keyof IConfiguration,
                                  newValue?.value! as string,
                                  { shouldDirty: true, shouldValidate: true }
                                );
                                setValue(
                                  "rules.importFile.contactIdName" as keyof IConfiguration,
                                  "",
                                  { shouldDirty: true, shouldValidate: true }
                                );
                              }}
                            />
                          )}
                        />
                      </FormControl>
                    </div>
                    {(watch("rules.importFile.appendType") ===
                      AppendType.appendonly || watch("rules.importFile.appendType") ===
                      AppendType.flushandappend) && (
                        <AppendOperationsSection
                          control={control}
                          watch={watch}
                          setValue={setValue}
                          register={register}
                          fileSpecTemplateList={fileSpecTemplateList}
                          importTemplateList={importTemplateList}
                          selectedImportTemplate={selectedImportTemplate}
                          setSelectedImportTemplate={setSelectedImportTemplate}
                          splittingCriteriaContactLists={splittingCriteriaContactLists}
                          setSplittingCriteriaContactLists={setSplittingCriteriaContactLists}
                          contactListItems={contactListItems}
                          contactListColumns={contactListColumns}
                          validateSplittingCriteriaColumns={validateSplittingCriteriaColumns}
                          handlePopulateSplittingCriteria={handlePopulateSplittingCriteria}
                        />
                      )}
                    {watch("rules.importFile.appendType") ===
                      AppendType.newlistsonly && (
                      <>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1">
                          <div className="mt-2 text">
                            Contact List Configuration
                          </div>
                          <div className="row">
                            <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-3">
                              <span className="text">
                                Trim leading/trailing whitespace
                              </span>
                              <Controller
                                name="rules.importFile.contactListConfiguration.trimWhitespace"
                                control={control}
                                render={({ field }) => (
                                  <Switch
                                    {...field}
                                    size="small"
                                    disabled={watch(
                                      "rules.importFile.contactListConfiguration.useImportTemplate"
                                    )}
                                    checked={field.value} // Use field.value to reflect the form value
                                  />
                                )}
                              />
                            </div>
                            <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-3">
                              <div className="mb-2 d-flex">
                                <FormControl
                                  sx={{ width: "100%" }}
                                  size="small"
                                >
                                  <Controller
                                    name="rules.importFile.contactListConfiguration.division.id"
                                    control={control}
                                    rules={{ required: "Division is required" }}
                                    render={({ field }) => (
                                      <Autocomplete
                                        {...field}
                                        onChange={(_event, newValue) => {
                                          setValue(
                                            "rules.importFile.contactListConfiguration.division.id" as keyof IConfiguration,
                                            newValue?.id || "",
                                            { shouldDirty: true, shouldValidate: true }
                                          );
                                        }}
                                        value={
                                          domainList.find(
                                            (domain) =>
                                              domain.id === watch(field.name)
                                          ) || null
                                        }
                                        disablePortal
                                        size="small"
                                        sx={{ width: "100%" }}
                                        options={domainList}
                                        getOptionLabel={(option) => option.name}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            size="small"
                                            label="Division *"
                                          />
                                        )}
                                      />
                                    )}
                                  />
                                </FormControl>
                              </div>
                            </div>

                            {storageType !== "API" && (
                              <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-3">
                                <span className="text">
                                  Use Specification File
                                </span>
                                <Controller
                                  name="rules.importFile.contactListConfiguration.useSpecificationFile"
                                  control={control}
                                  render={({ field }) => (
                                    <Switch
                                      {...field}
                                      size="small"
                                      checked={field.value} // Use field.value to reflect the form value
                                    />
                                  )}
                                />
                              </div>
                            )}
                            {storageType !== "API" && (
                              <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-3">
                                <div className="mb-2 d-flex">
                                  <FormControl
                                    sx={{ width: "100%" }}
                                    size="small"
                                  >
                                    <Controller
                                      name="rules.importFile.fileSpecificationTemplateId"
                                      disabled={
                                        !watch(
                                          "rules.importFile.contactListConfiguration.useSpecificationFile"
                                        )
                                      }
                                      control={control}
                                      rules={{
                                        required:
                                          "fileSpecificationTemplateId is required",
                                      }}
                                      render={({ field }) => (
                                        <Autocomplete
                                          {...field}
                                          onChange={(_event, newValue) => {
                                            setValue(
                                              "rules.importFile.fileSpecificationTemplateId" as keyof IConfiguration,
                                              newValue?.id || "",
                                              { shouldDirty: true, shouldValidate: true }
                                            );
                                          }}
                                          value={
                                            fileSpecTemplateList.find(
                                              (fileTemplateList) =>
                                                fileTemplateList.id ===
                                                watch(field.name)
                                            ) || null
                                          }
                                          disablePortal
                                          size="small"
                                          sx={{ width: "100%" }}
                                          options={fileSpecTemplateList}
                                          getOptionLabel={(option) => option.name}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              size="small"
                                              label="File Specification Template *"
                                            />
                                          )}
                                        />
                                      )}
                                    />
                                  </FormControl>
                                </div>
                              </div>
                            )}
                            <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-3">
                              <span className="text">Use Import Template</span>
                              <Controller
                                name="rules.importFile.contactListConfiguration.useImportTemplate"
                                control={control}
                                render={({ field }) => (
                                  <Switch
                                    {...field}
                                    size="small"
                                    checked={field.value} // Use field.value to reflect the form value
                                    onChange={(e) => {
                                      field.onChange(e);
                                      if (!e.target.checked) {
                                        setSelectedImportTemplate(null);
                                        setSplittingCriteriaContactLists([]);
                                        setValue("rules.importFile.importTemplateId" as keyof IConfiguration, "", {
                                          shouldDirty: true,
                                          shouldValidate: true,
                                        });
                                      }
                                    }}
                                  />
                                )}
                              />
                            </div>
                            <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-3">
                              <div className="mb-2 d-flex">
                                <FormControl
                                  sx={{ width: "100%" }}
                                  size="small"
                                >
                                  <Controller
                                    name="rules.importFile.importTemplateId"
                                    disabled={
                                      !watch(
                                        "rules.importFile.contactListConfiguration.useImportTemplate"
                                      )
                                    }
                                    control={control}
                                    rules={{
                                      required: "importTemplateId is required",
                                    }}
                                    render={({ field }) => (
                                      <Autocomplete
                                        {...field}
                                        onChange={(_event, newValue) => {
                                          setValue(
                                            "rules.importFile.importTemplateId" as keyof IConfiguration,
                                            newValue?.id || "",
                                            { shouldDirty: true, shouldValidate: true }
                                          );
                                          setSelectedImportTemplate(newValue);
                                          const appendType = watch("rules.importFile.appendType");

                                          if (newValue?.useSplittingCriteria) {
                                            setSplittingCriteriaContactLists([""]);
                                          } else {
                                            setSplittingCriteriaContactLists([]);
                                          }
                                        }}
                                        value={
                                          importTemplateList.find(
                                            (importTemplate) =>
                                              importTemplate.id ===
                                              watch(field.name)
                                          ) || null
                                        }
                                        disablePortal
                                        size="small"
                                        sx={{ width: "100%" }}
                                        options={importTemplateList}
                                        getOptionLabel={(option) => option.name}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            size="small"
                                            label="Import Template *"
                                          />
                                        )}
                                      />
                                    )}
                                  />
                                </FormControl>
                              </div>
                            </div>

                            {!watch(
                              "rules.importFile.contactListConfiguration.useImportTemplate"
                            ) && (
                              <>
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-3">
                                  <span className="text">
                                    Upload contacts from a CSV or Excel file
                                  </span>
                                  <input
                                    type="file"
                                    ref={fileInputRef}
                                    className="form-control form-control-sm mt-1"
                                    onChange={handleFileUpload}
                                    accept=".csv, .xlsx, .xls"
                                  />
                                </div>
                                {excelData.length > 0 && (
                                  <>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-3">
                                      <TableContainer
                                        sx={{ maxHeight: 350 }}
                                        component={Paper}
                                      >
                                        <Table stickyHeader size="small">
                                          <TableHead>
                                            <TableRow>
                                              {Object.keys(excelData[0]).map(
                                                (header, index) => (
                                                  <TableCell key={index}>
                                                    {header}
                                                  </TableCell>
                                                )
                                              )}
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            {excelData.map((row, rowIndex) => (
                                              <TableRow key={rowIndex}>
                                                {Object.values(row).map(
                                                  (cell, cellIndex) => (
                                                    <TableCell key={cellIndex}>
                                                      {cell}
                                                    </TableCell>
                                                  )
                                                )}
                                              </TableRow>
                                            ))}
                                          </TableBody>
                                        </Table>
                                      </TableContainer>
                                    </div>
                                  </>
                                )}
                              </>
                            )}
                          </div>
                        </div>
                        {!watch(
                          "rules.importFile.contactListConfiguration.useImportTemplate"
                        ) && (
                          <>
                            {showPhoneMappingCols() && (
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-3">
                                <div className="text mt-1">
                                  Contact List Columns
                                </div>
                                <div className="text-500 mt-1">
                                  Phone Columns
                                </div>
                                {phoneFields.map((row, index) => (
                                  <div className="row" key={row.id}>
                                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 mt-1">
                                      <FormControl
                                        sx={{ width: "100%" }}
                                        size="small"
                                      >
                                        <Controller
                                          name={`rules.importFile.contactListConfiguration.phoneColumns.${index}.columnName`}
                                          control={control}
                                          rules={{
                                            required: "Column is required",
                                          }}
                                          render={({ field }) => (
                                            <Autocomplete
                                              disablePortal
                                              size="small"
                                              sx={{ width: "100%" }}
                                              {...field}
                                              value={watch(field.name) || ""}
                                              onChange={(_event, newValue) => {
                                                setValue(
                                                  field.name as keyof IConfiguration,
                                                  newValue as string,
                                                  { shouldDirty: true, shouldValidate: true }
                                                );
                                              }}
                                              options={excelHeaderCols}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  label="Column *"
                                                  size="small"
                                                />
                                              )}
                                            />
                                          )}
                                        />
                                      </FormControl>
                                    </div>
                                    <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 mt-1">
                                      <FormControl
                                        sx={{ width: "100%" }}
                                        size="small"
                                      >
                                        <Controller
                                          name={`rules.importFile.contactListConfiguration.phoneColumns.${index}.type`}
                                          control={control}
                                          rules={{
                                            required: "Type is required",
                                          }}
                                          render={({ field }) => (
                                            <Autocomplete
                                              disablePortal
                                              size="small"
                                              sx={{ width: "100%" }}
                                              {...field}
                                              onChange={(_event, newValue) => {
                                                setValue(
                                                  field.name as keyof IConfiguration,
                                                  newValue?.value || "",
                                                  { shouldDirty: true, shouldValidate: true }
                                                );
                                              }}
                                              value={
                                                PhoneTypes.find(
                                                  (phoneTypes) =>
                                                    phoneTypes.value ===
                                                    watch(field.name)
                                                ) || null
                                              }
                                              getOptionLabel={(option) =>
                                                option.displayValue
                                              }
                                              options={PhoneTypes}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  label="Type *"
                                                  size="small"
                                                />
                                              )}
                                            />
                                          )}
                                        />
                                      </FormControl>
                                    </div>
                                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 mt-1">
                                      <FormControl
                                        sx={{ width: "100%" }}
                                        size="small"
                                      >
                                        <Controller
                                          name={`rules.importFile.contactListConfiguration.phoneColumns.${index}.callableTimeColumn`}
                                          control={control}
                                          render={({ field }) => (
                                            <Autocomplete
                                              disablePortal
                                              size="small"
                                              sx={{ width: "100%" }}
                                              {...field}
                                              value={watch(field.name) || ""}
                                              onChange={(_event, newValue) => {
                                                setValue(
                                                  field.name as keyof IConfiguration,
                                                  newValue as string,
                                                  { shouldDirty: true, shouldValidate: true }
                                                );                                                
                                              }}
                                              options={excelHeaderCols}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  label="Time Zone Column"
                                                  size="small"
                                                />
                                              )}
                                            />
                                          )}
                                        />
                                      </FormControl>
                                    </div>
                                    <div className="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 mt-1">
                                      {phoneFields.length === index + 1 && (
                                        <IconButton
                                          onClick={() =>
                                            phoneAppend({
                                              columnName: "",
                                              type: "",
                                            })
                                          }
                                        >
                                          <AddIcon />
                                        </IconButton>
                                      )}
                                      {phoneFields.length !== index + 1 && (
                                        <IconButton
                                          onClick={() => phoneRemove(index)}
                                        >
                                          <RemoveIcon />
                                        </IconButton>
                                      )}
                                    </div>
                                  </div>
                                ))}
                                <div className="text-500 mt-1">
                                  Unique Identifier Column
                                </div>
                                  <div className="row">
                                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 mt-1">
                                      <FormControl
                                        sx={{ width: "100%" }}
                                        size="small"
                                      >
                                        <Controller
                                          name={`rules.importFile.contactIdName`}
                                          control={control}                                        
                                          render={({ field }) => (
                                            <Autocomplete
                                              disablePortal
                                              size="small"
                                              sx={{ width: "100%" }}
                                              {...field}
                                              value={watch(field.name) || ""}
                                              onChange={(_event, newValue) => {
                                                setValue(
                                                  field.name as keyof IConfiguration,
                                                  newValue as string,
                                                  { shouldDirty: true, shouldValidate: true }
                                                );
                                              }}
                                              options={excelHeaderCols}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  label="Column"
                                                  size="small"
                                                />
                                              )}
                                            />
                                          )}
                                        />
                                      </FormControl>
                                    </div>                                       
                                  </div>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </>
                )}

                {watch("rules.ruleType") === RulesType.exportContactList && (
                  <>
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 mt-30">
                      <Controller
                        name="rules.exportContactList.campaignId"
                        control={control}
                        render={({ field }) => (
                          <Autocomplete
                            disablePortal
                            size="small"
                            sx={{ width: "100%" }}
                            options={campaignList}
                            getOptionLabel={(option) => option.name}
                            {...field}
                            value={
                              campaignList.find(
                                (campaign) =>
                                  campaign.id ===
                                  watch("rules.exportContactList.campaignId")
                              ) || null
                            }
                            onChange={(_event, newValue) => {
                              setValue(
                                "rules.exportContactList.campaignId" as keyof IConfiguration,
                                newValue?.id,
                                { shouldDirty: true, shouldValidate: true }
                              );
                              setValue(
                                "rules.exportContactList.contactListId" as keyof IConfiguration,
                                "",
                                { shouldDirty: true, shouldValidate: true }
                              );
                              setValue(
                                "rules.exportContactList.phoneColumns" as keyof IConfiguration,
                                [] as any,
                                { shouldDirty: true, shouldValidate: true }
                              );
                              setValue(
                                "rules.exportContactList.contactList" as keyof IConfiguration,
                                "" as string,
                                { shouldDirty: true, shouldValidate: true }
                              );
                              if (newValue) {
                                const contact = contactListItems.find(
                                  (contact) =>
                                    contact.id === newValue.contactList.id                                    
                                );
                                if (contact) {
                                  setExportContactListItems([contact]);
                                } else {
                                  setExportContactListItems([]);
                                }
                              } else {
                                setExportContactListItems(contactListItems);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                label="Campaign"
                              />
                            )}
                          />
                        )}
                      />
                    </div>
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 mt-30">
                      <Controller
                        name="rules.exportContactList.contactList"
                        rules={{ required: "Contact List is required" }}
                        control={control}
                        render={({ field }) => (
                          <Autocomplete
                            disablePortal
                            size="small"
                            sx={{ width: "100%" }}
                            options={exportContactListItems}
                            getOptionLabel={(option) => option.name}
                            {...field}
                            value={
                              exportContactListItems.find(
                                (contact) =>
                                  contact.name ===
                                  watch("rules.exportContactList.contactList")
                              ) || null
                            }
                            onChange={(_event, newValue) => {
                              setValue(
                                "rules.exportContactList.contactListId" as keyof IConfiguration,
                                newValue?.id,
                                { shouldDirty: true, shouldValidate: true }
                              );
                              setValue(
                                "rules.exportContactList.phoneColumns" as keyof IConfiguration,
                                newValue?.phoneColumns,
                                { shouldDirty: true, shouldValidate: true }
                              );
                              setValue(
                                "rules.exportContactList.contactList" as keyof IConfiguration,
                                newValue?.name as string,
                                { shouldDirty: true, shouldValidate: true }
                              );
                              // Reset selected columns when contact list changes
                              setSelectedExportColumns([]);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                label="Contact List *"
                              />
                            )}
                          />
                        )}
                      />
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-30">
                      <div className="d-flex align-items-center mb-3">
                        <Button
                          variant="outlined"
                          size="small"
                          disabled={!watch("rules.exportContactList.contactListId")}
                          onClick={() => setIsColumnDialogOpen(true)}
                          sx={{ mr: 2 }}
                        >
                          Select Columns
                          {selectedExportColumns.length > 0
                            ? ` (${selectedExportColumns.length} selected)`
                            : ""}
                        </Button>
                      </div>
                      <ColumnSelectionDialog
                        open={isColumnDialogOpen}
                        contactListId={watch("rules.exportContactList.contactListId")}
                        initialSelectedColumns={selectedExportColumns}
                        onClose={() => setIsColumnDialogOpen(false)}
                        onConfirm={(cols) => {
                          setSelectedExportColumns(cols);
                          setIsColumnDialogOpen(false);
                        }}
                      />
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-30">
                      <div className="text mb-3">Output File Format Options</div>
                      <div className="row">
                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                    selectedAdditionalAttributeExport.includeCustomFileName
                                  }
                                  onChange={(_e, checked) => {
                                    setSelectedAdditionalAttributeExport({
                                      ...selectedAdditionalAttributeExport,
                                      includeCustomFileName: checked,
                                    });
                                    setValue(
                                      "serverDetails.additionalAttributes",
                                      {
                                        ...selectedAdditionalAttributeExport,
                                        includeCustomFileName: checked
                                          ? ""
                                          : false,
                                      } as any
                                    );
                                  }}
                                />
                              }
                              label=""
                          />
                          <TextField
                              label="Custom File Name *"
                              value={
                                selectedAdditionalAttributeExport.customFileName ||
                                ""
                              }
                              variant="outlined"
                              size="small"
                              disabled={
                                !selectedAdditionalAttributeExport.includeCustomFileName
                              }
                              sx={{ flex: 1 }}
                              onChange={(e) => {
                                const newValue = e.target.value;
                                setSelectedAdditionalAttributeExport({
                                  ...selectedAdditionalAttributeExport,
                                  customFileName: newValue,
                                });
                                setValue("serverDetails.additionalAttributes", {
                                  ...selectedAdditionalAttributeExport,
                                  customFileName: newValue,
                                } as any);
                              }}
                              placeholder="Enter custom file name"
                            />
                        </div>
                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                          <FormControlLabel
                              control={
                                <Checkbox
                                  checked={
                                    selectedAdditionalAttributeExport.includeDateInFileName === false ? false : true
                                  }
                                  onChange={(_e, checked) => {
                                    setSelectedAdditionalAttributeExport({
                                      ...selectedAdditionalAttributeExport,
                                      includeDateInFileName: checked,
                                    });
                                    setValue(
                                      "serverDetails.additionalAttributes",
                                      {
                                        ...selectedAdditionalAttributeExport,
                                        includeDateInFileName: checked,
                                      } as any
                                    );
                                  }}
                                />
                              }
                              label=""
                            />
                            <TextField
                              label="Include Date"
                              value={"YYYYMMDD"}
                              variant="outlined"
                              size="small"
                              disabled={
                                !selectedAdditionalAttributeExport.includeDateInFileName
                              }
                              sx={{ flex: 1 }}
                              InputProps={{ readOnly: true }}
                            />
                        </div>
                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                          <FormControlLabel
                              control={
                                <Checkbox
                                  checked={
                                    selectedAdditionalAttributeExport.includeTimeInFileName === false ? false : true
                                  }
                                  onChange={(_e, checked) => {
                                    setSelectedAdditionalAttributeExport({
                                      ...selectedAdditionalAttributeExport,
                                      includeTimeInFileName: checked,
                                    });
                                    setValue(
                                      "serverDetails.additionalAttributes",
                                      {
                                        ...selectedAdditionalAttributeExport,
                                        includeTimeInFileName: checked,
                                      } as any
                                    );
                                  }}
                                />
                              }
                              label=""
                            />
                            <TextField
                              label="Include Time"
                              value={"HHmmss"}
                              variant="outlined"
                              size="small"
                              disabled={
                                !selectedAdditionalAttributeExport.includeTimeInFileName
                              }
                              sx={{ flex: 1 }}
                              InputProps={{ readOnly: true }}
                              placeholder="HHmmss"
                            />
                        </div>
                      </div>
                    </div>
                    {/*<div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 mt-30">
                      <TextField
                        label="Output file name format"
                        variant="outlined"
                        size="small"
                        sx={{ width: "100%" }}
                        value={watch(
                          "rules.exportContactList.outputFileFormat"
                        )}
                        {...register(
                          "rules.exportContactList.outputFileFormat",
                          {
                            required: true,
                          }
                        )}
                      />
                        </div>*/}
                  </>
                )}

                {watch("rules.ruleType") === RulesType.importDNCList && (
                  <>
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 mt-30">
                      <FormControl sx={{ width: "100%" }} size="small">
                        <InputLabel id="demo-select-small-label">
                          File Format Operation
                        </InputLabel>
                        <Select
                          {...register(
                            "rules.importDNCList.fileFormatOperation",
                            {
                              required: storageType !== "API",
                            }
                          )}
                          label="File Format Operation"
                          disabled={storageType === "API"}
                          value={
                            watch("rules.importDNCList.fileFormatOperation") ||
                            ""
                          }
                        >
                          {FileFormatOperationTypeList.map((list, i) => (
                            <MenuItem value={list.value} key={i}>
                              {list.displayName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    {storageType === "API" ? (
                      <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 mt-30">
                        <TextField
                          label="List name *"
                          {...register("listName" as any, {
                            required: watch("rules.importDNCList.appendType") === AppendTypeForDNC.newlistsonly,
                          })}
                          value={watch("listName" as any) || ""}
                          variant="outlined"
                          size="small"
                          disabled={watch("rules.importDNCList.appendType") === AppendTypeForDNC.appendonly}
                          sx={{ width: "100%", padding: "0px 5px" }}
                        />
                      </div>
                    ) : (
                      <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 mt-30">
                        <TextField
                          label="File name format *"
                          {...register("rules.importDNCList.fileFormatName", {
                            required: true,
                          })}
                          value={
                            watch("rules.importDNCList.fileFormatName") || ""
                          }
                          variant="outlined"
                          size="small"
                          sx={{ width: "100%", padding: "0px 5px" }}
                        />
                      </div>
                    )}
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 mt-30">
                      <Controller
                        name="rules.importDNCList.contactListId"
                        rules={{
                          required:
                            watch("rules.importDNCList.appendType") ===
                            AppendType.appendonly
                              ? "DNC List is required"
                              : false,
                        }}
                        control={control}
                        render={({ field }) => (
                          <Autocomplete
                            disablePortal
                            size="small"
                            disabled={
                              watch("rules.importDNCList.appendType") ===
                              AppendType.newlistsonly
                            }
                            sx={{ width: "100%", padding: "0px 5px" }}
                            options={dncListItems}
                            getOptionLabel={(option) => option.name}
                            {...field}
                            value={
                              dncListItems.find(
                                (contact) =>
                                  contact.id ===
                                  watch("rules.importDNCList.contactListId")
                              ) || null
                            }
                            onChange={(_event, newValue) => {
                              setValue(
                                "rules.importDNCList.contactListId" as keyof IConfiguration,
                                newValue?.id,
                                { shouldDirty: true, shouldValidate: true }
                              );
                            }}
                            renderInput={(params) => (
                              <TextField {...params} label="DNC List *" />
                            )}
                          />
                        )}
                      />
                    </div>
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 mt-30">
                      <FormControl
                        sx={{ width: "100%", padding: "0px 5px" }}
                        size="small"
                      >
                        <Controller
                          name="rules.importDNCList.appendType"
                          control={control}
                          rules={{
                            required: "Append Type is required",
                          }}
                          render={({ field }) => (
                            <Autocomplete
                              disablePortal
                              size="small"
                              sx={{ width: "100%", padding: "0px 5px" }}
                              {...field}
                              options={AppendTypeListForDNC}
                              getOptionLabel={(option) => option.displayName}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  label="Append Type *"
                                />
                              )}
                              value={
                                AppendTypeListForDNC.find(
                                  (appendType) =>
                                    appendType.value ===
                                    watch("rules.importDNCList.appendType")
                                ) || null
                              }
                              onChange={(_, newValue) => {
                                setValue(
                                  "rules.importDNCList.appendType" as keyof IConfiguration,
                                  newValue?.value! as string,
                                  { shouldDirty: true, shouldValidate: true }
                                );
                              }}
                            />
                          )}
                        />
                      </FormControl>
                    </div>
                    {watch("rules.importDNCList.appendType") === AppendTypeForDNC.newlistsonly && (
                      <>
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 mt-30">
                          <FormControl
                            sx={{ width: "100%", padding: "0px 5px" }}
                            size="small"
                          >
                            <Controller
                              name="rules.importDNCList.dncSourceType"
                              control={control}
                              rules={{
                                required: "DNC List Type is required",
                              }}
                              render={({ field }) => (
                                <Autocomplete
                                  disablePortal
                                  size="small"
                                  sx={{ width: "100%", padding: "0px 5px" }}
                                  {...field}
                                  options={DNCSourceTypeList}
                                  getOptionLabel={(option) => option.displayName}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      size="small"
                                      label="DNC List Type *"
                                    />
                                  )}
                                  value={
                                    DNCSourceTypeList.find(
                                      (sourceType) =>
                                        sourceType.value ===
                                        watch("rules.importDNCList.dncSourceType")
                                    ) || DNCSourceTypeList[0]
                                  }
                                  onChange={(_, newValue) => {
                                    setValue(
                                      "rules.importDNCList.dncSourceType" as keyof IConfiguration,
                                      newValue?.value! as string,
                                      { shouldDirty: true, shouldValidate: true }
                                    );
                                  }}
                                />
                              )}
                            />
                          </FormControl>
                        </div>
                        {watch("rules.importDNCList.dncSourceType") === DNCSourceType.rds && (
                          <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 mt-30">
                            <FormControl
                              sx={{ width: "100%", padding: "0px 5px" }}
                              size="small"
                            >
                              <Controller
                                name="rules.importDNCList.contactMethod"
                                control={control}
                                rules={{
                                  required: "Contact Method is required",
                                }}
                                render={({ field }) => (
                                  <Autocomplete
                                    disablePortal
                                    size="small"
                                    sx={{ width: "100%", padding: "0px 5px" }}
                                    {...field}
                                    options={DNCContactMethodList}
                                    getOptionLabel={(option) => option.displayName}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        size="small"
                                        label="Contact Method *"
                                      />
                                    )}
                                    value={
                                      DNCContactMethodList.find(
                                        (method) =>
                                          method.value ===
                                          watch("rules.importDNCList.contactMethod")
                                      ) || null
                                    }
                                    onChange={(_, newValue) => {
                                      setValue(
                                        "rules.importDNCList.contactMethod" as keyof IConfiguration,
                                        newValue?.value! as string,
                                        { shouldDirty: true, shouldValidate: true }
                                      );
                                    }}
                                  />
                                )}
                              />
                            </FormControl>
                          </div>
                        )}
                      </>
                    )}
                    {(watch("rules.importDNCList.appendType") ===
                      AppendTypeForDNC.newlistsonly || watch("rules.importDNCList.appendType") ===
                      AppendTypeForDNC.appendonly) && (
                      <>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1">                        
                            {watch("rules.importDNCList.dncSourceType") !== DNCSourceType.rds && (
                              <div className="mt-2 text">
                                DNC List Configuration
                              </div>
                            )}
                            <div className="row">
                              
                              {watch("rules.importDNCList.appendType") ===
                              AppendTypeForDNC.newlistsonly && 
                              watch("rules.importDNCList.dncSourceType") !== DNCSourceType.rds && (
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-3">
                                <div className="mb-2 d-flex">
                                  <TextField
                                    label="Custom Exclusion Column *"
                                    {...register(
                                      "rules.importDNCList.contactListConfiguration.customExclusionColumn",
                                      {
                                        required: watch("rules.importDNCList.dncSourceType") !== DNCSourceType.rds,
                                      }
                                    )}
                                    value={
                                      watch(
                                        "rules.importDNCList.contactListConfiguration.customExclusionColumn"
                                      ) || ""
                                    }
                                    variant="outlined"
                                    size="small"
                                    sx={{ width: "100%", padding: "0px 5px" }}
                                  />
                                </div>
                              </div>
                              )}
                              {watch("rules.importDNCList.appendType") ===
                              AppendTypeForDNC.newlistsonly && (
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-3">
                                <div className="mb-2 d-flex">
                                  <FormControl
                                    sx={{ width: "100%" }}
                                    size="small"
                                  >
                                    <Controller
                                      name="rules.importDNCList.contactListConfiguration.division.id"
                                      control={control}
                                      rules={{ required: "Division is required" }}
                                      render={({ field }) => (
                                        <Autocomplete
                                          {...field}
                                          onChange={(_event, newValue) => {
                                            setValue(
                                              "rules.importDNCList.contactListConfiguration.division.id" as keyof IConfiguration,
                                              newValue?.id || "",
                                              { shouldDirty: true, shouldValidate: true }
                                            );
                                          }}
                                          value={
                                            domainList.find(
                                              (domain) =>
                                                domain.id === watch(field.name)
                                            ) || null
                                          }
                                          disablePortal
                                          size="small"
                                          sx={{ width: "100%" }}
                                          options={domainList}
                                          getOptionLabel={(option) => option.name}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              size="small"
                                              label="Division *"
                                            />
                                          )}
                                        />
                                      )}
                                    />
                                  </FormControl>
                                </div>
                              </div>
                              )}
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-3">
                                <span className="text">
                                  Upload contacts from a CSV or Excel file
                                </span>
                                <input
                                  type="file"
                                  ref={fileInputRef}
                                  className="form-control form-control-sm mt-1"
                                  onChange={handleFileUpload}
                                  accept=".csv, .xlsx, .xls"
                                />
                              </div>
                              {excelData.length > 0 && (
                                <>
                                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-3">
                                    <TableContainer
                                      sx={{ maxHeight: 350 }}
                                      component={Paper}
                                    >
                                      <Table stickyHeader size="small">
                                        <TableHead>
                                          <TableRow>
                                            {Object.keys(excelData[0]).map(
                                              (header, index) => (
                                                <TableCell key={index}>
                                                  {header}
                                                </TableCell>
                                              )
                                            )}
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          {excelData.map((row, rowIndex) => (
                                            <TableRow key={rowIndex}>
                                              {Object.values(row).map(
                                                (cell, cellIndex) => (
                                                  <TableCell key={cellIndex}>
                                                    {cell}
                                                  </TableCell>
                                                )
                                              )}
                                            </TableRow>
                                          ))}
                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                                  </div>
                                </>
                              )}
                            </div>                        
                        </div>
                        {showDNCCols() && (
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-3">
                            <div className="text mt-1">DNC List Columns</div>
                            <div className="row">
                              <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-1">
                                <FormControl
                                  sx={{ width: "100%" }}
                                  size="small"
                                >
                                  <Controller
                                    name="rules.importDNCList.contactListConfiguration.customExclusionColumns"
                                    control={control}
                                    rules={{
                                      required: "DNC Upload column is required",
                                    }}
                                    render={({ field }) => (
                                      <Autocomplete
                                        {...field}
                                        multiple
                                        options={excelHeaderCols}
                                        getOptionLabel={(option) => option}
                                        value={field.value}
                                        onChange={(event, newValue) =>
                                          field.onChange(newValue)
                                        }
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            variant="outlined"
                                            label="DNC Upload Columns *"
                                          />
                                        )}
                                      />
                                    )}
                                  />
                                </FormControl>
                              </div>
                              <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 mt-1">
                                <FormControl
                                  sx={{ width: "100%" }}
                                  size="small"
                                >
                                  <Controller
                                    name="rules.importDNCList.contactListConfiguration.expirationDateTimeColumn"
                                    control={control}
                                    render={({ field }) => (
                                      <Autocomplete
                                        {...field}
                                        options={excelHeaderCols}
                                        getOptionLabel={(option) => option}
                                        value={field.value}
                                        onChange={(event, newValue) =>
                                          field.onChange(newValue)
                                        }
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            variant="outlined"
                                            label="DNC Expiration Column"
                                          />
                                        )}
                                      />
                                    )}
                                  />
                                </FormControl>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}

                {watch("rules.ruleType") === RulesType.exportDNCList && (
                  <>
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 mt-30">
                      <Controller
                        name="rules.exportDNCList.campaignId"
                        control={control}
                        render={({ field }) => (
                          <Autocomplete
                            disablePortal
                            size="small"
                            sx={{ width: "100%" }}
                            options={campaignList}
                            getOptionLabel={(option) => option.name}
                            {...field}
                            value={
                              campaignList.find(
                                (campaign) =>
                                  campaign.id ===
                                  watch("rules.exportDNCList.campaignId")
                              ) || null
                            }
                            onChange={(_event, newValue) => {
                              setValue(
                                "rules.exportDNCList.campaignId" as keyof IConfiguration,
                                newValue?.id,
                                { shouldDirty: true, shouldValidate: true }
                              );
                              if (newValue) {
                                const currentCampaign = campaignList.find(
                                  (camp) => camp.id === newValue.id
                                );
                                if (currentCampaign) {
                                  const currentCampaignDncLists =
                                    currentCampaign.dncLists.map(
                                      (item) => item.id
                                    );
                                  if (currentCampaignDncLists) {
                                    const filteredDncList = dncListItems.find(
                                      (list) =>
                                        currentCampaignDncLists.includes(
                                          list.id
                                        )
                                    );
                                    if (filteredDncList) {
                                      setExportDNCItems([filteredDncList]);
                                    } else {
                                      setExportDNCItems([]);
                                    }
                                  } else {
                                    setExportDNCItems([]);
                                  }
                                } else {
                                  setExportDNCItems([]);
                                }
                              } else {
                                setExportDNCItems(contactListItems);
                              }
                              setExportDNCItems(dncListItems);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                label="Campaign"
                              />
                            )}
                          />
                        )}
                      />
                    </div>
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 mt-30">
                      <Controller
                        name="rules.exportDNCList.contactList"
                        rules={{ required: "DNC List is required" }}
                        control={control}
                        render={({ field }) => (
                          <Autocomplete
                            disablePortal
                            size="small"
                            sx={{ width: "100%" }}
                            options={exportDNCItems}
                            getOptionLabel={(option) => `${option.name}`}
                            {...field}
                            value={
                              exportDNCItems.find(
                                (contact) =>
                                  contact.id ===
                                  watch("rules.exportDNCList.contactListId")
                              ) || null
                            }
                            onChange={(_event, newValue) => {
                              setValue(
                                "rules.exportDNCList.contactListId" as keyof IConfiguration,
                                newValue?.id,
                                { shouldDirty: true, shouldValidate: true }
                              );
                              setValue(
                                "rules.exportDNCList.contactList" as keyof IConfiguration,
                                newValue?.name as string,
                                { shouldDirty: true, shouldValidate: true }
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                label="DNC List *"
                              />
                            )}
                          />
                        )}
                      />
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-30">
                      <div className="text mb-3">Output File Format Options</div>
                      <div className="row">
                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                    selectedAdditionalAttributeExport.includeCustomFileName
                                  }
                                  onChange={(_e, checked) => {
                                    setSelectedAdditionalAttributeExport({
                                      ...selectedAdditionalAttributeExport,
                                      includeCustomFileName: checked,
                                    });
                                    setValue(
                                      "serverDetails.additionalAttributes",
                                      {
                                        ...selectedAdditionalAttributeExport,
                                        includeCustomFileName: checked
                                          ? ""
                                          : false,
                                      } as any
                                    );
                                  }}
                                />
                              }
                              label=""
                          />
                          <TextField
                              label="Custom File Name"
                              value={
                                selectedAdditionalAttributeExport.customFileName ||
                                ""
                              }
                              variant="outlined"
                              size="small"
                              disabled={
                                !selectedAdditionalAttributeExport.includeCustomFileName
                              }
                              sx={{ flex: 1 }}
                              onChange={(e) => {
                                const newValue = e.target.value;
                                setSelectedAdditionalAttributeExport({
                                  ...selectedAdditionalAttributeExport,
                                  customFileName: newValue,
                                });
                                setValue("serverDetails.additionalAttributes", {
                                  ...selectedAdditionalAttributeExport,
                                  customFileName: newValue,
                                } as any);
                              }}
                              placeholder="Enter custom file name"
                            />
                        </div>
                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                          <FormControlLabel
                              control={
                                <Checkbox
                                  checked={
                                    selectedAdditionalAttributeExport.includeDateInFileName === false ? false : true
                                  }
                                  onChange={(_e, checked) => {
                                    setSelectedAdditionalAttributeExport({
                                      ...selectedAdditionalAttributeExport,
                                      includeDateInFileName: checked,
                                    });
                                    setValue(
                                      "serverDetails.additionalAttributes",
                                      {
                                        ...selectedAdditionalAttributeExport,
                                        includeDateInFileName: checked,
                                      } as any
                                    );
                                  }}
                                />
                              }
                              label=""
                            />
                            <TextField
                              label="Include Date"
                              value={"YYYYMMDD"}
                              variant="outlined"
                              size="small"
                              disabled={
                                !selectedAdditionalAttributeExport.includeDateInFileName
                              }
                              sx={{ flex: 1 }}
                              InputProps={{ readOnly: true }}
                            />
                        </div>
                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                          <FormControlLabel
                              control={
                                <Checkbox
                                  checked={
                                    selectedAdditionalAttributeExport.includeTimeInFileName === false ? false : true
                                  }
                                  onChange={(_e, checked) => {
                                    setSelectedAdditionalAttributeExport({
                                      ...selectedAdditionalAttributeExport,
                                      includeTimeInFileName: checked,
                                    });
                                    setValue(
                                      "serverDetails.additionalAttributes",
                                      {
                                        ...selectedAdditionalAttributeExport,
                                        includeTimeInFileName: checked,
                                      } as any
                                    );
                                  }}
                                />
                              }
                              label=""
                            />
                            <TextField
                              label="Include Time"
                              value={"HHmmss"}
                              variant="outlined"
                              size="small"
                              disabled={
                                !selectedAdditionalAttributeExport.includeTimeInFileName
                              }
                              sx={{ flex: 1 }}
                              InputProps={{ readOnly: true }}
                              placeholder="HHmmss"
                            />
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </Paper>
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mtw-30 mb-2 d-flex justify-content-end last-row-button">
            <Button
              variant="contained"
              size="medium"
              sx={{ marginRight: "20px" }}
              onClick={() => {
                navigate("../" + RoutesName.jobsview);
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              size="medium"
              sx={{
                color: "white",
                backgroundColor: "#1b2c48",
                marginRight: "5px",
              }}
              /*disabled={!isValid || !isSFTPCredsValid}*/
              disabled={disableForm()}
              type="submit"
            >
              Save Job
            </Button>
          </div>
        </div>
      </form>
      {getSnackDetails.open && (
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={getSnackDetails.open}
          autoHideDuration={5000}
          onClose={(_event, reason?: string) => {
            if (reason === "clickaway") {
              return;
            }
            setSnackDetails({ open: false, message: <></>, severity: "error" });
          }}
        >
          <Alert
            severity={getSnackDetails.severity as AlertColor}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {getSnackDetails.message as ReactNode}
          </Alert>
        </Snackbar>
      )}
    </Paper>
  );
};

export default Configuration;
